// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file bay_session_shared.proto (package evenplay.bay_session.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_capability } from "./capability_pb";
import type { Message as Message$1 } from "./notification_pb";
import { file_notification } from "./notification_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bay_session_shared.proto.
 */
export const file_bay_session_shared: GenFile = /*@__PURE__*/
  fileDesc("ChhiYXlfc2Vzc2lvbl9zaGFyZWQucHJvdG8SF2V2ZW5wbGF5LmJheV9zZXNzaW9uLnYxIu4CChhQbGF5ZXJTZWxlY3RDb25maXJtYXRpb24SDwoHdXNlcl9pZBgBIAEoAxJICgZzdGF0dXMYAiABKA4yOC5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5QbGF5ZXJTZWxlY3RDb25maXJtYXRpb24uU3RhdHVzIvYBCgZTdGF0dXMSMQotUExBWUVSX1NFTEVDVF9DT05GSVJNQVRJT05fU1RBVFVTX1VOU1BFQ0lGSUVEEAASKAokUExBWUVSX1NFTEVDVF9DT05GSVJNQVRJT05fU1RBVFVTX05BEAESLgoqUExBWUVSX1NFTEVDVF9DT05GSVJNQVRJT05fU1RBVFVTX0FXQUlUSU5HEAISLgoqUExBWUVSX1NFTEVDVF9DT05GSVJNQVRJT05fU1RBVFVTX0FDQ0VQVEVEEAMSLworUExBWUVSX1NFTEVDVF9DT05GSVJNQVRJT05fU1RBVFVTX1RJTUVEX09VVBAEIloKFENvbmZpcm1hdGlvblNldHRpbmdzEhQKB29uX3R1cm4YASABKAhIAIgBARIUCgdvbl9zaG90GAIgASgISAGIAQFCCgoIX29uX3R1cm5CCgoIX29uX3Nob3QivggKDFNlc3Npb25TdGF0ZRISCgpzdGF0aW9uX2lkGAEgASgDEjsKCXBsYXlfbW9kZRgCIAEoDjIoLmV2ZW5wbGF5LmJheV9zZXNzaW9uLnYxLlNlc3Npb25QbGF5TW9kZRJLChlkZWZhdWx0X211bHRpX3BsYXllcl9tb2RlGAMgASgOMiguZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuU2Vzc2lvblBsYXlNb2RlEhYKDmFjdGl2ZV91c2VyX2lkGAQgASgDEjcKB3BsYXllcnMYBSADKAsyJi5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5TZXNzaW9uUGxheWVyEjgKCHJvdGF0aW9uGAYgASgLMiYuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuUm90YXRpb25TdGF0ZRIVCg10b3VybmFtZW50X2lkGAcgASgDEi4KCnVwZGF0ZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjYKCmZyc19zdGF0dXMYCSABKAsyIi5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5GcnNTdGF0dXMSVQoacGxheWVyX3NlbGVjdF9jb25maXJtYXRpb24YCiABKAsyMS5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5QbGF5ZXJTZWxlY3RDb25maXJtYXRpb24SJQodbXVsdGlfcGxheWVyX2luX2dhbWVwbGF5X2FyZWEYCyABKAgSHgoWc2hvd19tdWx0aXBsYXllcl9lcnJvchgMIAEoCBIuCiZzaG93X3BsYXllcl9ub3RfaW5fZ2FtZXBsYXlfYXJlYV9lcnJvchgNIAEoCBIVCg1hY3RpdmVfYmV0X2lkGA4gASgJEhkKEWFjdGl2ZV9iZXRfYW1vdW50GA8gASgDEhkKEXNob3RfYXJtZWRfYmV0X2lkGBkgASgJEhIKCmRiX3ZlcnNpb24YECABKAMSQAoOYmFzZV9wbGF5X21vZGUYESABKA4yKC5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5TZXNzaW9uUGxheU1vZGUSHAoUaXNfcHVibGljX3RvdXJuYW1lbnQYEiABKAgSQAoPdG91cm5hbWVudF90eXBlGBMgASgOMicuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuVG91cm5hbWVudFR5cGUSFwoPdG91cm5hbWVudF9uYW1lGBQgASgJEkUKC2xlYWRlcmJvYXJkGBUgAygLMjAuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuVG91cm5hbWVudFN0YW5kaW5nRW50cnkSOgoPYWN0aXZlX21lc3NhZ2VzGBogAygLMiEuZXZlbnBsYXkubm90aWZpY2F0aW9uLnYxLk1lc3NhZ2USGQoRYWN0aXZlX2dlbmVyYXRpb24YGyABKAMikAEKCUZyc1N0YXR1cxIVCg1mcnNfcGxheWVyX2lkGAEgASgDEhgKEGZyc19tdWx0aV9wbGF5ZXIYAiABKAgSOQoVZnJzX2xhc3RfZGV0ZWN0aW9uX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIXCg9pZGxlX3RpbWVvdXRfbXMYBCABKAUijwoKDVNlc3Npb25QbGF5ZXISDwoHdXNlcl9pZBgBIAEoAxISCgpmaXJzdF9uYW1lGAIgASgJEhEKCWxhc3RfbmFtZRgDIAEoCRIQCgh1c2VybmFtZRgEIAEoCRISCgpqb2luX29yZGVyGAUgASgFEjYKCndhZ2VyX21vZGUYBiABKA4yIi5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5XYWdlck1vZGUSQwoMY29uZmlybWF0aW9uGAcgASgLMi0uZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuQ29uZmlybWF0aW9uU2V0dGluZ3MSEQoJaXNfYWN0aXZlGAggASgIEh0KFXRhcmdldF9kaXN0YW5jZV95YXJkcxgJIAEoAxInCh9wcmV2aWV3ZWRfdGFyZ2V0X2Rpc3RhbmNlX3lhcmRzGAogASgDEiMKG3ByZXZpZXdlZF9uZXh0X3RhcmdldF95YXJkcxgLIAEoAxImCh5wcmV2aW91c190YXJnZXRfZGlzdGFuY2VfeWFyZHMYDCABKAMSRAoXcHJldmlvdXNfdGFyZ2V0X291dGNvbWUYDSABKA4yIy5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5CZXRPdXRjb21lEhgKEGhhc19hY2NlcHRlZF9iZXQYDiABKAgSDwoHaXNfaWRsZRgPIAEoCBIVCg1hY3RpdmVfYmV0X2lkGBAgASgJEhgKEGFjdGl2ZV9iZXRfc3RhdGUYESABKAkSGQoRYWN0aXZlX2JldF9hbW91bnQYEiABKAMSHQoVYWN0aXZlX2JldF9tdWx0aXBsaWVyGBMgASgDEhcKD2FjdGl2ZV9iZXRfdHlwZRgWIAEoCRIdChVhdXRvX2NvbnRpbnVlX2VuYWJsZWQYFCABKAgSIQoZYXV0b19jb250aW51ZV93YWdlcl9jZW50cxgVIAEoAxITCgtza2lsbF9pbmRleBgXIAEoBRJQChhhdXRvX3BsYXlfYmFsYW5jZV9zdGF0dXMYGCABKA4yLi5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5BdXRvUGxheUJhbGFuY2VTdGF0dXMSFQoNaXNfbmV3X3BsYXllchgZIAEoCBIXCg9mcmVlX3BsYXlfY291bnQYGiABKAUSIQoZY29tcGxldGVkX2ZyZWVfcGxheV9jb3VudBgbIAEoBRI/ChNhbGxvd2VkX3dhZ2VyX21vZGVzGBwgAygOMiIuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuV2FnZXJNb2RlEg4KBmlzX3ZpcBgdIAEoCBI7CglyZWFkaW5lc3MYHiABKA4yKC5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5QbGF5ZXJSZWFkaW5lc3MSQAoSd2FnZXJzX2J5X2N1cnJlbmN5GB8gAygLMiQuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuUGxheWVyV2FnZXISPAoFZnVuZHMYICADKAsyLS5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5DdXJyZW5jeUF2YWlsYWJpbGl0eRISCgpoYW5kZWRuZXNzGCEgASgJEhsKE3VzZF9tYXhfd2FnZXJfY2VudHMYIiABKAMSSwoQZW5naW5lX2F1dG9fcGxheRgjIAEoCzIxLmV2ZW5wbGF5LmJheV9zZXNzaW9uLnYxLkVuZ2luZUF1dG9QbGF5UHJlZmVyZW5jZSJmCgtQbGF5ZXJXYWdlchIQCghjdXJyZW5jeRgBIAEoCRIOCgZiZXRfaWQYAiABKAkSEQoJYmV0X3N0YXRlGAMgASgJEg4KBmFtb3VudBgEIAEoAxISCgptdWx0aXBsaWVyGAUgASgDIu0BCg1Sb3RhdGlvblN0YXRlEhkKEWN1cnJlbnRfcGxheWVyX2lkGAEgASgDEhYKDm5leHRfcGxheWVyX2lkGAIgASgDEhMKC3Nob3RzX3Rha2VuGAMgASgFEhcKD3Nob3RzX3JlbWFpbmluZxgEIAEoBRIWCg5zaG90c19wZXJfdHVybhgFIAEoBRIVCg10dXJuX2NvbXBsZXRlGAYgASgIEhQKDHBsYXllcl9vcmRlchgHIAMoAxIdChVhd2FpdGluZ19jb25maXJtYXRpb24YCCABKAgSFwoPdGltZW91dF9zZWNvbmRzGAkgASgFItIBCglGcnNVcGRhdGUSEgoKc3RhdGlvbl9pZBgBIAEoAxItCglzZW5kX3RpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEj0KDHdlYmNhbV9zdGF0ZRgDIAMoCzInLmV2ZW5wbGF5LmJheV9zZXNzaW9uLnYxLkZyc1dlYmNhbVN0YXRlEg0KBXRva2VuGAQgASgJEhQKDGZyc190cmFja19pZBgFIAEoCRIeChZmcnNfaWRlbnRpZmljYXRpb25fa2V5GAYgASgJIr4DCg5GcnNXZWJjYW1TdGF0ZRIRCgl3ZWJjYW1faWQYASABKAkSMAoMY2FwdHVyZV90aW1lGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIVCg1mYWNlX2RldGVjdGVkGAMgASgIEg8KB3VzZXJfaWQYBCABKAMSEwoLcHJvYmFiaWxpdHkYBSABKAISHwoXbXVsdGlwbGVfaHVtYW5fZGV0ZWN0ZWQYBiABKAgSIAoYbnVtYmVyX29mX2h1bWFuX2RldGVjdGVkGAcgASgFEjoKBHNpZGUYCCABKA4yLC5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5GcnNXZWJjYW1TdGF0ZS5TaWRlEioKIm51bWJlcl9vZl9odW1hbl9pbl9kZXRlY3RhYmxlX2FyZWEYCSABKAUSIgoadXNlcl9pZF9pbl9kZXRlY3RhYmxlX2FyZWEYCiABKAMSKAogZmFjZV9kZXRlY3RlZF9pbl9kZXRlY3RhYmxlX2FyZWEYCyABKAgiMQoEU2lkZRIUChBTSURFX1VOU1BFQ0lGSUVEEAASCAoETEVGVBABEgkKBVJJR0hUEAIiiAEKCUhlYXJ0YmVhdBIQCghzZXF1ZW5jZRgBIAEoAxIrCgdzZW50X2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpkYl92ZXJzaW9uGAMgASgDEhQKDHN1Yl9zZXF1ZW5jZRgEIAEoAxISCgpzdGF0aW9uX2lkGAUgASgDIpIHCgtQbGF5ZXJTdGF0ZRIPCgd1c2VyX2lkGAEgASgDEhoKEmN1cnJlbnRfc3RhdGlvbl9pZBgCIAEoAxI+Cg5zZXNzaW9uX3BsYXllchgDIAEoCzImLmV2ZW5wbGF5LmJheV9zZXNzaW9uLnYxLlNlc3Npb25QbGF5ZXISQwoRc3RhdGlvbl9wbGF5X21vZGUYBCABKA4yKC5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5TZXNzaW9uUGxheU1vZGUSLgoKdXBkYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASRQoSdXNlcl9zZXNzaW9uX3N0YXRlGAYgASgOMikuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuVXNlclNlc3Npb25TdGF0ZRIXCg9pc19zZXNzaW9uX2Z1bGwYByABKAgSJwofYWNjb3VudF9zZWN1cml0eV9ieXBhc3NfZW5hYmxlZBgIIAEoCBISCgpkYl92ZXJzaW9uGAkgASgDEh0KFWF3YWl0aW5nX2NvbmZpcm1hdGlvbhgKIAEoCBIgChhhY3RpdmVfcGxheWVyX2ZpcnN0X25hbWUYCyABKAkSOAoIcm90YXRpb24YDCABKAsyJi5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5Sb3RhdGlvblN0YXRlEmYKGnJvdGF0aW9uX3BhcnRpY2lwYW50X25hbWVzGA0gAygLMkIuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuUGxheWVyU3RhdGUuUm90YXRpb25QYXJ0aWNpcGFudE5hbWVzRW50cnkSGQoRc2hvdF9hcm1lZF9iZXRfaWQYDiABKAkSSwoVdG91cm5hbWVudF9qb2luX29mZmVyGA8gASgLMiwuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuVG91cm5hbWVudEpvaW5PZmZlchI6Cg9hY3RpdmVfbWVzc2FnZXMYECADKAsyIS5ldmVucGxheS5ub3RpZmljYXRpb24udjEuTWVzc2FnZRI8CgVmdW5kcxhkIAMoCzItLmV2ZW5wbGF5LmJheV9zZXNzaW9uLnYxLkN1cnJlbmN5QXZhaWxhYmlsaXR5Gj8KHVJvdGF0aW9uUGFydGljaXBhbnROYW1lc0VudHJ5EgsKA2tleRgBIAEoAxINCgV2YWx1ZRgCIAEoCToCOAEiSwoUQ3VycmVuY3lBdmFpbGFiaWxpdHkSEAoIY3VycmVuY3kYASABKAkSEQoJYXZhaWxhYmxlGAIgASgDEg4KBmxvY2tlZBgDIAEoAyJZChdUb3VybmFtZW50U3RhbmRpbmdFbnRyeRIMCgRyYW5rGAEgASgFEg8KB3VzZXJfaWQYAiABKAMSEAoIdXNlcm5hbWUYAyABKAkSDQoFc2NvcmUYBCABKAMiLAoTVG91cm5hbWVudEpvaW5PZmZlchIVCg10b3VybmFtZW50X2lkGAEgASgDIicKEUFja01lc3NhZ2VSZXF1ZXN0EhIKCm1lc3NhZ2VfaWQYASABKAkiFAoSQWNrTWVzc2FnZVJlc3BvbnNlIjoKE0xlYXZlU2Vzc2lvblJlcXVlc3QSEgoKc3RhdGlvbl9pZBgBIAEoAxIPCgd1c2VyX2lkGAIgASgDIk4KFExlYXZlU2Vzc2lvblJlc3BvbnNlEjYKB3Nlc3Npb24YASABKAsyJS5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5TZXNzaW9uU3RhdGUiLAoWR2V0U2Vzc2lvblN0YXRlUmVxdWVzdBISCgpzdGF0aW9uX2lkGAEgASgDIk8KF0dldFNlc3Npb25TdGF0ZVJlc3BvbnNlEjQKBXN0YXRlGAEgASgLMiUuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuU2Vzc2lvblN0YXRlImEKGVN0cmVhbVNlc3Npb25TdGF0ZVJlcXVlc3QSEgoKc3RhdGlvbl9pZBgBIAEoAxIWCg5zaW5jZV9zZXF1ZW5jZRgCIAEoAxIYChBzaW5jZV9kYl92ZXJzaW9uGAMgASgDIowBCiRTZXRQbGF5ZXJDb25maXJtYXRpb25TZXR0aW5nc1JlcXVlc3QSEgoKc3RhdGlvbl9pZBgBIAEoAxIPCgd1c2VyX2lkGAIgASgDEj8KCHNldHRpbmdzGAMgASgLMi0uZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuQ29uZmlybWF0aW9uU2V0dGluZ3MiXwolU2V0UGxheWVyQ29uZmlybWF0aW9uU2V0dGluZ3NSZXNwb25zZRI2CgZwbGF5ZXIYASABKAsyJi5ldmVucGxheS5iYXlfc2Vzc2lvbi52MS5TZXNzaW9uUGxheWVyIlwKG1NldE5leHRXYWdlckN1cnJlbmN5UmVxdWVzdBISCgpzdGF0aW9uX2lkGAEgASgDEhAKCGN1cnJlbmN5GAIgASgJEhcKD2lkZW1wb3RlbmN5X2tleRgDIAEoCSJWChxTZXROZXh0V2FnZXJDdXJyZW5jeVJlc3BvbnNlEjYKBnBsYXllchgBIAEoCzImLmV2ZW5wbGF5LmJheV9zZXNzaW9uLnYxLlNlc3Npb25QbGF5ZXIiYgoaU3dpdGNoV2FnZXJDdXJyZW5jeVJlcXVlc3QSEgoKc3RhdGlvbl9pZBgBIAEoAxIXCg90YXJnZXRfY3VycmVuY3kYAiABKAkSFwoPaWRlbXBvdGVuY3lfa2V5GAMgASgJIpgBChtTd2l0Y2hXYWdlckN1cnJlbmN5UmVzcG9uc2USNgoGcGxheWVyGAEgASgLMiYuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuU2Vzc2lvblBsYXllchIZChFwcmV2aW91c19jdXJyZW5jeRgCIAEoCRIUCgxuZXdfY3VycmVuY3kYAyABKAkSEAoIcmVtaW50ZWQYBCABKAgiJgoUR2V0QmV0RGV0YWlsc1JlcXVlc3QSDgoGYmV0X2lkGAEgASgJIpkCChVHZXRCZXREZXRhaWxzUmVzcG9uc2USDgoGYmV0X2lkGAEgASgJEhEKCWJldF9zdGF0ZRgCIAEoCRISCgpiZXRfYW1vdW50GAMgASgDEhAKCGN1cnJlbmN5GAQgASgJEhIKCnN0YXRpb25faWQYBSABKAMSDwoHdXNlcl9pZBgGIAEoAxI5CgpjaGFsbGVuZ2VzGAcgAygLMiUuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuQmV0Q2hhbGxlbmdlEjUKCHBheWxpbmVzGAggAygLMiMuZXZlbnBsYXkuYmF5X3Nlc3Npb24udjEuQmV0UGF5bGluZRIgChhob2xlX2luX29uZV9ib251c19hbW91bnQYCSABKAMibgoMQmV0Q2hhbGxlbmdlEhQKDGNoYWxsZW5nZV9pZBgBIAEoAxIQCghzZXF1ZW5jZRgCIAEoBRIWCg5jaGFsbGVuZ2VfdHlwZRgDIAEoCRIOCgZ2YWx1ZTEYBCABKAMSDgoGdmFsdWUyGAUgASgDIlwKCkJldFBheWxpbmUSEgoKcGF5bGluZV9pZBgBIAEoAxIUCgxjaGFsbGVuZ2VfaWQYAiABKAMSEgoKbXVsdGlwbGllchgDIAEoAxIQCghwcmlvcml0eRgEIAEoAyJSChhFbmdpbmVBdXRvUGxheVByZWZlcmVuY2USDwoHZW5hYmxlZBgBIAEoCBIPCgd1c2VfbWF4GAIgASgIEhQKDHBpbm5lZF9jZW50cxgDIAEoAyrmAQoPU2Vzc2lvblBsYXlNb2RlEiEKHVNFU1NJT05fUExBWV9NT0RFX1VOU1BFQ0lGSUVEEAASGgoWU0VTU0lPTl9QTEFZX01PREVfU09MTxABEhoKFlNFU1NJT05fUExBWV9NT0RFX09QRU4QAhIeChpTRVNTSU9OX1BMQVlfTU9ERV9ST1RBVElPThADEhkKFVNFU1NJT05fUExBWV9NT0RFX0ZSUxAEEhsKF1NFU1NJT05fUExBWV9NT0RFX0VWRU5UEAUSIAocU0VTU0lPTl9QTEFZX01PREVfVE9VUk5BTUVOVBAGKnAKD011bHRpUGxheWVyTW9kZRIhCh1NVUxUSV9QTEFZRVJfTU9ERV9VTlNQRUNJRklFRBAAEhoKFk1VTFRJX1BMQVlFUl9NT0RFX09QRU4QARIeChpNVUxUSV9QTEFZRVJfTU9ERV9ST1RBVElPThACKngKFUF1dG9QbGF5QmFsYW5jZVN0YXR1cxIYChRBVVRPX1BMQVlfQkFMQU5DRV9PSxAAEiEKHUFVVE9fUExBWV9CQUxBTkNFX0RPV05TSElGVEVEEAESIgoeQVVUT19QTEFZX0JBTEFOQ0VfSU5TVUZGSUNJRU5UEAIqfAoJV2FnZXJNb2RlEhMKD1dBR0VSX01PREVfTk9ORRAAEhQKEFdBR0VSX01PREVfTU9ORVkQARIVChFXQUdFUl9NT0RFX1BPSU5UUxACEhcKE1dBR0VSX01PREVfUFJBQ1RJQ0UQBCIECAMQAyoOV0FHRVJfTU9ERV9GU1AqmAEKD01vbmV5Q2FwYWJpbGl0eRIgChxNT05FWV9DQVBBQklMSVRZX1VOU1BFQ0lGSUVEEAASHwobTU9ORVlfQ0FQQUJJTElUWV9SRUFMX01PTkVZEAESIAocTU9ORVlfQ0FQQUJJTElUWV9QT0lOVFNfT05MWRACEiAKHE1PTkVZX0NBUEFCSUxJVFlfVU5LTk9XTl9CQVkQAyqIAQoKQmV0T3V0Y29tZRIbChdCRVRfT1VUQ09NRV9VTlNQRUNJRklFRBAAEhMKD0JFVF9PVVRDT01FX1dPThABEhQKEEJFVF9PVVRDT01FX0xPU1QQAhIZChVCRVRfT1VUQ09NRV9DQU5DRUxMRUQQAxIXChNCRVRfT1VUQ09NRV9FWFBJUkVEEAQqiQEKD1BsYXllclJlYWRpbmVzcxIgChxQTEFZRVJfUkVBRElORVNTX1VOU1BFQ0lGSUVEEAASGQoVUExBWUVSX1JFQURJTkVTU19QTEFZEAESGwoXUExBWUVSX1JFQURJTkVTU19QQVVTRUQQAhIcChhQTEFZRVJfUkVBRElORVNTX0NPTkZJUk0QAyq7AQoKTG9ja1N0YXR1cxIbChdMT0NLX1NUQVRVU19VTlNQRUNJRklFRBAAEhYKEkxPQ0tfU1RBVFVTX0FDVElWRRABEhsKF0xPQ0tfU1RBVFVTX1RVUk5fTE9DS0VEEAISGwoXTE9DS19TVEFUVVNfSURMRV9MT0NLRUQQAxIbChdMT0NLX1NUQVRVU19VU0VSX0xPQ0tFRBAEEiEKHUxPQ0tfU1RBVFVTX0dVQVJESUFOX1JFUVVJUkVEEAUqmwEKEFVzZXJTZXNzaW9uU3RhdGUSIgoeVVNFUl9TRVNTSU9OX1NUQVRFX1VOU1BFQ0lGSUVEEAASIQodVVNFUl9TRVNTSU9OX1NUQVRFX05PVF9KT0lORUQQARIhCh1VU0VSX1NFU1NJT05fU1RBVEVfTk9UX0FDVElWRRACEh0KGVVTRVJfU0VTU0lPTl9TVEFURV9BQ1RJVkUQAyqHAQoOVG91cm5hbWVudFR5cGUSHwobVE9VUk5BTUVOVF9UWVBFX1VOU1BFQ0lGSUVEEAASGgoWVE9VUk5BTUVOVF9UWVBFX1BVQkxJQxABEhsKF1RPVVJOQU1FTlRfVFlQRV9QUklWQVRFEAISGwoXVE9VUk5BTUVOVF9UWVBFX0ZSSUVORFMQA0JRWk9naXRodWIuY29tL0V2ZW5QbGF5L2V2ZW5wbGF5LW1vbm8vbGlicy9wcm90b3MvcGtnL2JheV9zZXNzaW9uL3YxO2JheV9zZXNzaW9uX3YxYgZwcm90bzM", [file_google_protobuf_timestamp, file_capability, file_notification]);

/**
 * PlayerSelectConfirmation — kiosk-side parity field surfaced on
 * SessionState so the burrito-golf-web TurnConfirmationDialog can
 * cross-check its own state against the bay-session truth. Mirrors the
 * semantics of FullSwingSessionPlayerSelectConfirmation from the legacy
 * partner-service participation stream (BSA-4-4 parity field — see
 * partner_service.proto).
 *
 * The bay-session pod sources three of the four values (SMG-3214):
 *
 *   * AWAITING — a turn confirmation is owed. In ROTATION:
 *                RotationState.awaiting_confirmation is true AND a
 *                current_player_id is set (DERIVED from the rotation
 *                flag). In OPEN play (OPEN-play turn confirmation): the
 *                persisted awaiting_confirmation gate is armed — by a
 *                SetActivePlayer switch to a confirm_on_turn player —
 *                AND an active_user_id is set; with no RotationState on
 *                the wire this field is the station stream's only
 *                carrier of the armed gate. user_id carries the player
 *                who owes the confirmation in both modes.
 *   * ACCEPTED — the active player explicitly confirmed their turn via
 *                RespondToConfirmation(accepted=true). user_id carries
 *                that player. SOURCED from the persisted per-player
 *                bay_session_players.confirmation_outcome column — the
 *                outcome is NOT derivable once awaiting_confirmation
 *                clears. Projection precedence: AWAITING (if the flag is
 *                set) > ACCEPTED (active player's persisted outcome) >
 *                N_A.
 *   * N_A      — every other state (SOLO/EVENT/FRS play_mode, no active
 *                player, awaiting cleared with no ACCEPTED outcome).
 *                user_id is 0.
 *
 * TIMED_OUT is emitted by the rotation turn-timeout sweeper (SMG-3243,
 * rotation_turn_timeout_sweeper.go): when the active player's turn clock
 * expires the sweeper stamps confirmation_outcome = TIMED_OUT and
 * advances the rotation, publishing SESSION_TURN_TIMED_OUT.
 *
 * @generated from message evenplay.bay_session.v1.PlayerSelectConfirmation
 */
export type PlayerSelectConfirmation = Message<"evenplay.bay_session.v1.PlayerSelectConfirmation"> & {
  /**
   * 0 when status is N_A / UNSPECIFIED
   *
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: evenplay.bay_session.v1.PlayerSelectConfirmation.Status status = 2;
   */
  status: PlayerSelectConfirmation_Status;
};

/**
 * Describes the message evenplay.bay_session.v1.PlayerSelectConfirmation.
 * Use `create(PlayerSelectConfirmationSchema)` to create a new message.
 */
export const PlayerSelectConfirmationSchema: GenMessage<PlayerSelectConfirmation> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 0);

/**
 * @generated from enum evenplay.bay_session.v1.PlayerSelectConfirmation.Status
 */
export enum PlayerSelectConfirmation_Status {
  /**
   * @generated from enum value: PLAYER_SELECT_CONFIRMATION_STATUS_UNSPECIFIED = 0;
   */
  PLAYER_SELECT_CONFIRMATION_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAYER_SELECT_CONFIRMATION_STATUS_NA = 1;
   */
  PLAYER_SELECT_CONFIRMATION_STATUS_NA = 1,

  /**
   * @generated from enum value: PLAYER_SELECT_CONFIRMATION_STATUS_AWAITING = 2;
   */
  PLAYER_SELECT_CONFIRMATION_STATUS_AWAITING = 2,

  /**
   * @generated from enum value: PLAYER_SELECT_CONFIRMATION_STATUS_ACCEPTED = 3;
   */
  PLAYER_SELECT_CONFIRMATION_STATUS_ACCEPTED = 3,

  /**
   * @generated from enum value: PLAYER_SELECT_CONFIRMATION_STATUS_TIMED_OUT = 4;
   */
  PLAYER_SELECT_CONFIRMATION_STATUS_TIMED_OUT = 4,
}

/**
 * Describes the enum evenplay.bay_session.v1.PlayerSelectConfirmation.Status.
 */
export const PlayerSelectConfirmation_StatusSchema: GenEnum<PlayerSelectConfirmation_Status> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 0, 0);

/**
 * ConfirmationSettings — per-player, persisted in bay_session_players.
 * Spec §8. Optional fields express "no change" / "default" semantics.
 *
 * @generated from message evenplay.bay_session.v1.ConfirmationSettings
 */
export type ConfirmationSettings = Message<"evenplay.bay_session.v1.ConfirmationSettings"> & {
  /**
   * ROTATION only; null = default (false) / off (opt-in); true = require per-turn confirm
   *
   * @generated from field: optional bool on_turn = 1;
   */
  onTurn?: boolean;

  /**
   * All modes; null = default (false) / off (opt-in); true = require per-shot confirm
   *
   * @generated from field: optional bool on_shot = 2;
   */
  onShot?: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.ConfirmationSettings.
 * Use `create(ConfirmationSettingsSchema)` to create a new message.
 */
export const ConfirmationSettingsSchema: GenMessage<ConfirmationSettings> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 1);

/**
 * SessionState — full, self-contained station state snapshot. Returned by
 * GetSessionState; pushed in StreamSessionState updates. Spec §15.2.
 *
 * @generated from message evenplay.bay_session.v1.SessionState
 */
export type SessionState = Message<"evenplay.bay_session.v1.SessionState"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: evenplay.bay_session.v1.SessionPlayMode play_mode = 2;
   */
  playMode: SessionPlayMode;

  /**
   * OPEN or ROTATION; drives auto-transition
   *
   * @generated from field: evenplay.bay_session.v1.SessionPlayMode default_multi_player_mode = 3;
   */
  defaultMultiPlayerMode: SessionPlayMode;

  /**
   * 0 = no active player
   *
   * @generated from field: int64 active_user_id = 4;
   */
  activeUserId: bigint;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.SessionPlayer players = 5;
   */
  players: SessionPlayer[];

  /**
   * non-nil only when play_mode=ROTATION
   *
   * @generated from field: evenplay.bay_session.v1.RotationState rotation = 6;
   */
  rotation?: RotationState;

  /**
   * tournament_id is the id of the tournament currently governing the
   * bay. Non-zero in TWO modes:
   *   - play_mode=EVENT       — the scheduled bay-takeover event's id.
   *   - play_mode=TOURNAMENT  — the active player's tournament id
   *                             (TRN-BSA). The simulator pulls the
   *                             tournament's immutable metadata
   *                             (name / images) ONCE per id via TRN-1's
   *                             metadata RPC and caches it; that data is
   *                             deliberately never pushed per-publish.
   * 0 in all other modes.
   *
   * @generated from field: int64 tournament_id = 7;
   */
  tournamentId: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * FRS detection state — populated whenever the bay-session has been in
   * FRS mode (current or historical). nil means "FRS has never run at
   * this station". Subscribers can rely on this field's presence to
   * detect "we have FRS context" without reading play_mode.
   *
   * @generated from field: evenplay.bay_session.v1.FrsStatus frs_status = 9;
   */
  frsStatus?: FrsStatus;

  /**
   * BSA-4-4 stream parity: defensive cross-check for the kiosk's
   * TurnConfirmationDialog. The bay-session pod emits AWAITING (rotation
   * awaiting_confirmation==true), ACCEPTED (active player's persisted
   * confirmation_outcome, SMG-3214), or N_A. TIMED_OUT is still reserved
   * (SMG-3243). See the PlayerSelectConfirmation docstring for the
   * projection-precedence rule.
   *
   * @generated from field: evenplay.bay_session.v1.PlayerSelectConfirmation player_select_confirmation = 10;
   */
  playerSelectConfirmation?: PlayerSelectConfirmation;

  /**
   * multi_player_in_gameplay_area mirrors SSC's
   * StationState.CurrentState == MULTI_PLAYER instant-detection check
   * that runs at the START of the hit precondition (before user fetch).
   * Today bay-session collapses this onto the same FRS multi-player
   * flag as show_multiplayer_error; both fields are derived from the
   * post-debounce frs_status.frs_multi_player truth. Separate field
   * preserved for surface parity with SSC's two-stage gate.
   *
   * @generated from field: bool multi_player_in_gameplay_area = 11;
   */
  multiPlayerInGameplayArea: boolean;

  /**
   * show_multiplayer_error mirrors SSC's StationState.show_multiplayer_error.
   * True when the post-debounce FRS state reports
   * frs_multi_player == true.
   *
   * @generated from field: bool show_multiplayer_error = 12;
   */
  showMultiplayerError: boolean;

  /**
   * show_player_not_in_gameplay_area_error mirrors SSC's
   * StationState.show_player_not_in_game_play_area_error. True when
   * play_mode == FRS, an active player is set (active_user_id != 0),
   * and the post-debounce FRS state reports no player detection
   * (frs_player_id == 0). Today bay-session does not split detectable
   * vs gameplay areas in persisted state; the consolidated "no current
   * FRS detection for the active player" approximation is the
   * conservative wire signal — a hit is only allowed when the active
   * player is actually visible to the camera fleet.
   *
   * @generated from field: bool show_player_not_in_gameplay_area_error = 13;
   */
  showPlayerNotInGameplayAreaError: boolean;

  /**
   * ── Active bet surface (BSA-9-7-D1) ──────────────────────────────────
   *
   * Station-level active bet, populated whenever an smg_bet row for this
   * station is in state 'accepted' or 'committed' (the lifecycle window
   * in which the kiosk shows the bet to the player). Cleared on settle
   * or refund.
   *
   * Field name + types preserve parity with the legacy
   * smg.StationState.activeBetId (uint64) / betAmount (int64) the burrito
   * kiosk reads at apps/burrito-golf-web/src/store/session-state-store.ts.
   * active_bet_id is stringified for forward-compat with the future
   * smg_bet.bet_id int64→UUID migration (matches the AcceptBetResponse /
   * StartHitResponse bet_id contracts which already string-encode the id).
   *
   * active_bet_amount is in minor units of the bet's currency (cents for
   * USD, 1:1 for points currencies such as TGPTS / FSPTS). 0 when no
   * active bet.
   *
   * Proto3 default semantics: an unset active_bet_id is the empty string
   * and an unset active_bet_amount is 0; both mean "no active bet."
   * Minimal-snapshot publishers (StartHit / ProcessShot / CancelBet)
   * MUST set these fields explicitly on the synthetic snapshot so
   * subscribers do not have to distinguish "field omitted" from "field
   * cleared" — the merge semantics of the §13.9 supersedure model are
   * at the SessionState level, not per-field.
   *
   * @generated from field: string active_bet_id = 14;
   */
  activeBetId: string;

  /**
   * @generated from field: int64 active_bet_amount = 15;
   */
  activeBetAmount: bigint;

  /**
   * shot_armed_bet_id is the bet_id (stringified int64) the per-shot
   * confirmation handshake has armed for the active player. Empty
   * string when no shot is armed (the typical autoplay flow OR a
   * CBS-on player who has not yet tapped Play in the mobile app).
   *
   * Set inside the per-shot RespondToConfirmation(accepted=true)
   * handler; cleared by ProcessShot's CommitAcceptedBet CAS. SMG-3076:
   * surfaced on the wire so the kiosk can gate its phase=shot_ready
   * transition on (active_bet_id is set) AND (player does NOT require
   * per-shot confirmation OR shot_armed_bet_id == active_bet_id) —
   * without this signal the kiosk treated every accepted bet as
   * "ready to fire" which is wrong for CBS-on players in
   * autoplay-on-by-default sessions.
   *
   * @generated from field: string shot_armed_bet_id = 25;
   */
  shotArmedBetId: string;

  /**
   * ── Causal-ordering watermark (BSA-FU-PANEL-XPOD-4) ────────────────
   *
   * Strict-monotonic per-row version counter the BSA-FU-XPOD-ORDERING
   * consumer dedupes against (see SessionStateUpdate.db_version for the
   * wire-side rule). Sourced from bay_session_state.db_version, which
   * the UpdateBaySessionState query increments by 1 on every commit
   * under the FOR UPDATE row lock. Any two distinct commits on the same
   * station produce distinct db_version values regardless of wall-clock
   * resolution — the property the legacy updated_at.UnixMicro()
   * derivation could not guarantee under same-microsecond collisions.
   *
   * 0 means "row not yet UPDATEd post-migration" (BSA-FU-PANEL-XPOD-4).
   * The producer's snapshotDBVersion helper falls back to
   * updated_at.UnixMicro() in that case so the wire surface still
   * carries a deterministic non-zero watermark on the first publish.
   *
   * @generated from field: int64 db_version = 16;
   */
  dbVersion: bigint;

  /**
   * ── Tournament base-mode memory (TRN-BSA) ────────────────────────────
   *
   * base_play_mode records the play_mode the bay was running BEFORE it
   * transiently switched to TOURNAMENT, so the session can be restored
   * when the active player's tournament participation completes
   * (rotation -> rotation, open -> open, solo -> solo).
   *
   * Populated ONLY while play_mode == SESSION_PLAY_MODE_TOURNAMENT;
   * SESSION_PLAY_MODE_UNSPECIFIED (the proto3 default) in every other
   * mode. It is never itself TOURNAMENT (the base mode is whatever
   * non-tournament mode preceded the switch). Consumers restoring the
   * mode read this field; outside TOURNAMENT mode it carries no meaning.
   *
   * @generated from field: evenplay.bay_session.v1.SessionPlayMode base_play_mode = 17;
   */
  basePlayMode: SessionPlayMode;

  /**
   * ── Tournament access classification (SMG-3537) ──────────────────────
   *
   * Populated ONLY while play_mode == SESSION_PLAY_MODE_TOURNAMENT; the
   * proto3 defaults (false / TOURNAMENT_TYPE_UNSPECIFIED) in every other
   * mode. Both are derived from the governing tournament's is_private +
   * friends attributes, sourced from core over the internal
   * GetActiveTournamentForPlayer RPC and persisted alongside tournament_id.
   *
   * Legacy consumes this for: end-screen title ("Tournaments Entry
   * Complete!" vs "Friends Challenge Entry Complete!"), leaderboard title
   * ("TOURNAMENT LEADERBOARD" vs "FRIENDS CHALLENGE LEADERBOARD"), and the
   * next-up player panel (shown only for !is_public_tournament).
   *
   * is_public_tournament is the legacy binary (== !is_private ==
   * tournament_type == TOURNAMENT_TYPE_PUBLIC); tournament_type carries the
   * full three-way access classification for consumers that need it.
   *
   * @generated from field: bool is_public_tournament = 18;
   */
  isPublicTournament: boolean;

  /**
   * @generated from field: evenplay.bay_session.v1.TournamentType tournament_type = 19;
   */
  tournamentType: TournamentType;

  /**
   * ── Tournament display name (SMG-3560) ───────────────────────────────
   *
   * Populated ONLY while play_mode == SESSION_PLAY_MODE_TOURNAMENT; empty
   * string in every other mode. Mirrored from the core tournament model,
   * sourced from the same GetActiveTournamentForPlayer ENTER read as
   * tournament_id/is_public_tournament and persisted alongside them — so the
   * kiosk gets the name on the stream WITHOUT the separate
   * GetTournamentMetadata pull-once-cache path. Immutable for the
   * tournament's lifetime.
   *
   * @generated from field: string tournament_name = 20;
   */
  tournamentName: string;

  /**
   * ── Tournament standings (SMG-3560) ──────────────────────────────────
   *
   * leaderboard carries the current tournament standings (rank-ordered) so
   * ALL kiosks — not just the shooter who just settled — can render a live
   * standings panel from the stream. Populated ONLY while play_mode ==
   * SESSION_PLAY_MODE_TOURNAMENT; empty otherwise.
   *
   * Backed by a settle-refreshed cache, NOT a per-publish fetch: standings
   * change only when a shot settles, so bay-session persists the result of
   * the post-settle GetTournamentStandings read (already issued for the
   * ProcessShot response) onto bay_session_state and this builder projects
   * the persisted copy. That keeps SessionState — which republishes on every
   * station mutation — free of any per-publish standings RPC.
   *
   * @generated from field: repeated evenplay.bay_session.v1.TournamentStandingEntry leaderboard = 21;
   */
  leaderboard: TournamentStandingEntry[];

  /**
   * Station-scoped notification messages currently active for this bay
   * (SMG-3330). Projected by bay-session from its NotificationService
   * subscription: station-targeted messages plus active broadcasts,
   * never per-player messages (those ride PlayerState.active_messages so
   * the kiosk/shared display never sees another player's private
   * messages). Empty when no messages are active or the projection is
   * unwired. The authoritative store is NotificationService; this is a
   * read-side projection carried on the existing snapshot.
   *
   * @generated from field: repeated evenplay.notification.v1.Message active_messages = 26;
   */
  activeMessages: Message$1[];

  /**
   * Monotonic identity of the current active-player epoch. It advances when
   * an empty active slot is assigned or ownership moves to another player,
   * and is preserved when the slot is cleared. A simulator must return this
   * value with a timeout command so Bay can reject an event from an older
   * activation of the same user in the same session. 0 means that no active
   * epoch has been established yet (or that the producer predates SMG-4001).
   *
   * @generated from field: int64 active_generation = 27;
   */
  activeGeneration: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.SessionState.
 * Use `create(SessionStateSchema)` to create a new message.
 */
export const SessionStateSchema: GenMessage<SessionState> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 2);

/**
 * FrsStatus — bay-session's view of the FRS pipeline's last-known
 * detection state. Mirrors the bay_session_state.frs_* columns. The
 * detection pipeline writes to these columns via PushFrsUpdate's
 * asymmetric-dwell debouncer; the snapshot here is the post-debounce
 * truth, not the raw frame stream.
 *
 * Fields:
 *   * frs_player_id: 0 when no player is detected (NO_PLAYER/MULTI states
 *     leave this as the LAST seen player_id when MULTI is transient, or
 *     0 when the dwell has confirmed NO_PLAYER).
 *   * frs_multi_player: true when the multi-camera union reported
 *     multiple_human_detected=true on at least one camera and the
 *     short-dwell (3 frames) has elapsed.
 *   * frs_last_detection_at: server clock at the post-debounce
 *     transition. nil = never detected.
 *   * idle_timeout_ms: operator-supplied idle threshold persisted by
 *     SetFrsMode. 0 means "no timeout" (the idle sweep is dormant for
 *     that station). The bay-session pod's idle-FRS sweeper consumes
 *     this per-session value (SMG-3217): a station whose externally-set
 *     active player has aged past its own idle_timeout_ms since the arm
 *     is auto-cleared and a SESSION_FRS_NO_PLAYER event is published.
 *
 * @generated from message evenplay.bay_session.v1.FrsStatus
 */
export type FrsStatus = Message<"evenplay.bay_session.v1.FrsStatus"> & {
  /**
   * 0 = no detection
   *
   * @generated from field: int64 frs_player_id = 1;
   */
  frsPlayerId: bigint;

  /**
   * @generated from field: bool frs_multi_player = 2;
   */
  frsMultiPlayer: boolean;

  /**
   * nil = never detected
   *
   * @generated from field: google.protobuf.Timestamp frs_last_detection_at = 3;
   */
  frsLastDetectionAt?: Timestamp;

  /**
   * @generated from field: int32 idle_timeout_ms = 4;
   */
  idleTimeoutMs: number;
};

/**
 * Describes the message evenplay.bay_session.v1.FrsStatus.
 * Use `create(FrsStatusSchema)` to create a new message.
 */
export const FrsStatusSchema: GenMessage<FrsStatus> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 3);

/**
 * SessionPlayer — one participant in the session.
 *
 * @generated from message evenplay.bay_session.v1.SessionPlayer
 */
export type SessionPlayer = Message<"evenplay.bay_session.v1.SessionPlayer"> & {
  /**
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: string username = 4;
   */
  username: string;

  /**
   * @generated from field: int32 join_order = 5;
   */
  joinOrder: number;

  /**
   * @generated from field: evenplay.bay_session.v1.WagerMode wager_mode = 6;
   */
  wagerMode: WagerMode;

  /**
   * @generated from field: evenplay.bay_session.v1.ConfirmationSettings confirmation = 7;
   */
  confirmation?: ConfirmationSettings;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * Bet preview window — mirrors FullSwingSessionParticipant fields 11-15.
   *
   * @generated from field: int64 target_distance_yards = 9;
   */
  targetDistanceYards: bigint;

  /**
   * @generated from field: int64 previewed_target_distance_yards = 10;
   */
  previewedTargetDistanceYards: bigint;

  /**
   * @generated from field: int64 previewed_next_target_yards = 11;
   */
  previewedNextTargetYards: bigint;

  /**
   * @generated from field: int64 previous_target_distance_yards = 12;
   */
  previousTargetDistanceYards: bigint;

  /**
   * @generated from field: evenplay.bay_session.v1.BetOutcome previous_target_outcome = 13;
   */
  previousTargetOutcome: BetOutcome;

  /**
   * @generated from field: bool has_accepted_bet = 14;
   */
  hasAcceptedBet: boolean;

  /**
   * True when the durable per-station timeout_locked gate is engaged.
   * The FullSwing timeout bridge writes this marker through
   * MarkPlayerTimedOut. It is independent of lock_status and the user's
   * account-level preference.
   *
   * @generated from field: bool is_idle = 15;
   */
  isIdle: boolean;

  /**
   * ── Per-player active bet projection ──────────────────────────────
   *
   * The bet belongs to the player, not the station — when the player
   * moves stations, their open bet moves with them. These fields
   * expose the smg_bet row in state 'accepted' or 'committed' whose
   * user_id matches this player's. Empty / 0 when the player has no
   * active bet.
   *
   * active_bet_id is stringified for forward-compat with the future
   * bet_id int64→UUID migration (matches AcceptBetResponse.bet_id /
   * StartHitResponse.bet_id which already string-encode the id).
   *
   * active_bet_state is the smg_bet.bet_state string ("accepted" /
   * "committed"); kept as a string rather than an enum so this proto
   * does not couple to the engine's bet_state vocabulary.
   *
   * active_bet_amount + active_bet_multiplier are in minor units of the
   * bet's currency (cents for USD, 1:1 for points currencies such as
   * TGPTS / FSPTS). multiplier is cents-of-multiplier (100 = 1.0×).
   *
   * @generated from field: string active_bet_id = 16;
   */
  activeBetId: string;

  /**
   * @generated from field: string active_bet_state = 17;
   */
  activeBetState: string;

  /**
   * @generated from field: int64 active_bet_amount = 18;
   */
  activeBetAmount: bigint;

  /**
   * @generated from field: int64 active_bet_multiplier = 19;
   */
  activeBetMultiplier: bigint;

  /**
   * active_bet_type mirrors smg_bet.bet_type for the currently-active
   * bet. Bay-session's AcceptBet writes "challenge_<challenge_id>"
   * (see acceptBetTypeForChallenge in apps/.../bay-session/cmd/
   * .../accept_bet.go) — a stable per-challenge identifier. The
   * legacy smg-core AcceptBet path writes "paytable" as a single-
   * bucket UI-tab category; consumers migrating to consume this
   * field instead of the legacy getBets response MUST drop the
   * === "paytable" literal check and treat the value as opaque-
   * per-challenge (e.g. startsWith("challenge_") if a guard is
   * required at all — under BSA each player has at most one
   * active bet so most consumers don't need the gate). Empty
   * string when the player has no active bet (proto3 default).
   *
   * @generated from field: string active_bet_type = 22;
   */
  activeBetType: string;

  /**
   * ── Autoplay (auto-continue) projection ───────────────────────────
   *
   * Surfaces the bay_session_players.auto_continue_{enabled,wager_cents}
   * columns. SetAutoContinue toggles these in lockstep with engine's
   * per-user autoplay flag. wager_cents=0 means "use engine's
   * per-user setting" (no per-player pin).
   *
   * @generated from field: bool auto_continue_enabled = 20;
   */
  autoContinueEnabled: boolean;

  /**
   * @generated from field: int64 auto_continue_wager_cents = 21;
   */
  autoContinueWagerCents: bigint;

  /**
   * SMG-3062: skill_index from smg_skill_index.skill_index. Projected on
   * every SessionPlayer row so the sim's roster can show "Name (SI:42)"
   * next to each player. Non-sensitive identity-adjacent value (already
   * displayed on the legacy SSC kiosk surface). 0 when the player has no
   * smg_skill_index row yet (new players pre-first-shot).
   *
   * @generated from field: int32 skill_index = 23;
   */
  skillIndex: number;

  /**
   * ── Engine per-user projections (SMG-3075) ─────────────────────────
   *
   * Replaces what smg-core's GetUser.user exposed for: autoplay balance
   * status, new-player gate, and free-play counter. bay-session reads
   * these from engine.user_details when building the snapshot and
   * surfaces them on every SessionPlayer row. Empty / zero / OK on
   * engine unreachable (proto3 defaults).
   *
   * Why on SessionPlayer rather than a separate GetUserInfo RPC:
   * every consumer that needs these fields (mobile play-state pill,
   * cross-app harness assertions) already subscribes to PlayerState /
   * SessionState. Adding them to SessionPlayer means no extra
   * round-trip and no stale-poll risk.
   *
   * @generated from field: evenplay.bay_session.v1.AutoPlayBalanceStatus auto_play_balance_status = 24;
   */
  autoPlayBalanceStatus: AutoPlayBalanceStatus;

  /**
   * is_new_player mirrors the legacy
   * SmgService.GetUser.user.is_new_player derivation
   * (completed_free_play_count < free_play_count). Surfaced separately
   * so consumers don't have to redo the comparison.
   *
   * @generated from field: bool is_new_player = 25;
   */
  isNewPlayer: boolean;

  /**
   * free_play_count is the user's configured free-play allowance from
   * engine.user_details. 0 when the user has no free-play allocation.
   *
   * @generated from field: int32 free_play_count = 26;
   */
  freePlayCount: number;

  /**
   * completed_free_play_count is the number of free plays the user has
   * already consumed. Together with free_play_count it drives the
   * is_new_player gate.
   *
   * @generated from field: int32 completed_free_play_count = 27;
   */
  completedFreePlayCount: number;

  /**
   * SMG-3076: per-player allowed wager modes — the intersection of
   * this player's tier capability set with the station's jurisdiction-
   * level allowed currencies. The mobile uses this to render the
   * wager-mode picker; SMG-3078 will use the same intersection
   * server-side to reject out-of-tier SetWagerMode / AcceptBet calls.
   *
   * Tier capability sets (SMG-3087, 2026-06-04 — category vocabulary):
   *   GUEST              -> {PRACTICE}
   *   MINOR              -> {POINTS, PRACTICE}
   *   ADULT_UNCONFIRMED  -> {MONEY, POINTS, PRACTICE}
   *   ADULT_KYC_VALIDATED-> {MONEY, POINTS, PRACTICE}
   *   ADULT_KYC_FAILED   -> {POINTS, PRACTICE}
   *
   * Jurisdiction filter: points-only states drop MONEY (no USD in
   * the allowed currency set) regardless of tier; venues without a
   * configured points currency drop POINTS. The actual currency set
   * comes from venue × venue_partner × station_rules layering
   * (locationconfig.EffectiveConfig.AllowedCurrencies); category
   * membership is derived from "is at least one currency of that
   * category in the allowed set".
   *
   * Until the station_allowed_currencies wiring through sessionsnap
   * ships (tracked as a follow-on ticket), this field carries the
   * tier capability set WITHOUT jurisdiction narrowing. Consumers
   * should not treat the field as authoritative for jurisdiction
   * gating until the follow-on lands; the wallet still enforces
   * jurisdiction at the bet level.
   *
   * Repeated field; empty (proto3 default) when the player has no
   * tier resolved (transient: pre-eligibility-populate ordering).
   *
   * @generated from field: repeated evenplay.bay_session.v1.WagerMode allowed_wager_modes = 28;
   */
  allowedWagerModes: WagerMode[];

  /**
   * SMG-3151 (v1.1 E2): VIP badge — TRUE once the player has turned
   * over their first bonus amount. Projected from
   * smg_user_details.first_bonus_turned_over by populatePlayerVIP.
   *
   * The mobile renders a VIP-style indicator on the player tile when
   * this is TRUE. FALSE on accounts with no smg_user_details row (new
   * account) and on accounts whose bonus has not yet been turned over —
   * both are "under-badge rather than mis-badge" defaults: a player who
   * has earned the badge but predates the column's data simply does
   * not display it (the E1 companion ticket lands the turnover
   * trigger that flips the column).
   *
   * @generated from field: bool is_vip = 29;
   */
  isVip: boolean;

  /**
   * SMG-3147 (v1.1 D2): per-player swing-readiness classifier driving
   * both the kiosk "Ready" UX (D4) and the ProcessShot hit-rejection
   * gate (D3). See the PlayerReadiness enum for the derivation rules.
   *
   * Pure-projection field — derived in sessionsnap.Build from the
   * BaySessionPlayer.Locked + .LockStatus + .WagerMode columns plus
   * the containing SessionState.PlayMode / FRSPlayerID / ActiveUserID
   * for the FRS business rule. No new persistence — all four sources
   * are already on the read path.
   *
   * UNSPECIFIED (proto3 default) is the safer-side under-spec value
   * emitted only when no enum case applies (today that's unreachable:
   * every BaySessionPlayer resolves to one of PLAY / PAUSED / CONFIRM).
   * Subscribers should treat UNSPECIFIED as PAUSED-equivalent (do not
   * let a swing through) — safer to over-pause than to over-allow.
   *
   * @generated from field: evenplay.bay_session.v1.PlayerReadiness readiness = 30;
   */
  readiness: PlayerReadiness;

  /**
   * SMG-3138 (v1.1 B2): per-currency wager projection. One entry per
   * (user, station, currency) row in bay_session_wagers (substrate
   * landed by SMG-3137 v1.1 B1). Multi-wager substrate: a player may
   * hold one wager per currency simultaneously (e.g. one USD + one
   * TGPTS + one FSPTS); each entry is an independent
   * smg_bet / wager-lifecycle pair.
   *
   * Sorted by `currency` ASC for byte-stable wire ordering — the
   * snapshot publisher's xpod dedup relies on identical inputs
   * producing identical byte sequences. Consumers MUST NOT rely on
   * a specific currency being at a specific index; iterate the slice
   * and key by `currency` when a particular currency is needed.
   *
   * Back-compat with the legacy active_bet_* projection on
   * SessionPlayer (fields 16-19, 22): during the v1.1 transition
   * window both projections coexist. active_bet_* points at the
   * single wager whose currency matches the player's current
   * `wager_mode` category (e.g. MONEY -> USD, POINTS -> TGPTS / FSPTS
   * per venue config, PRACTICE -> PRACTICE); new code MUST consume
   * `wagers_by_currency` directly so it can render the full
   * multi-wager set. B5 retires the active_bet_* readers; until then
   * the two projections are derived from the same Wagers slice.
   *
   * Empty (proto3 default repeated) when the player holds no open
   * wagers at this station — the common case for a fresh roster
   * member.
   *
   * @generated from field: repeated evenplay.bay_session.v1.PlayerWager wagers_by_currency = 31;
   */
  wagersByCurrency: PlayerWager[];

  /**
   * SMG-3245: per-currency wallet availability for THIS player, projected
   * onto the station stream so the operator/kiosk (burrito-golf-web) can
   * render each seated player's balance — the kiosk consumes the station
   * SessionState stream, not the per-player PlayerState stream where
   * PlayerState.funds (field 100) lives.
   *
   * PRIVACY NOTE: unlike PlayerState.funds (subject-only on the private
   * per-player stream), this projects every roster member's balance onto
   * the station stream, which any station-stream subscriber sees. This is
   * an intentional operator-trust decision for the bay kiosk — the
   * station stream is the venue-side view. Same minor-unit + available/
   * locked semantics as CurrencyAvailability; populated by the station
   * projection's funds-enrichment pass (enrichSessionPlayerFunds), nil
   * when the wallet read fails (best-effort, never blocks the snapshot).
   *
   * @generated from field: repeated evenplay.bay_session.v1.CurrencyAvailability funds = 32;
   */
  funds: CurrencyAvailability[];

  /**
   * Player handedness ("left" / "right" / "" when unset), projected from
   * the joined smg_user.handedness column at snapshot time (same name-and-
   * profile enrichment pass as first_name / last_name / username). Surfaced
   * on the station stream so the bay/simulator and kiosk know which side
   * each seated player addresses the ball from. Empty string when the user
   * has no handedness recorded. Read-only here; the write paths remain user
   * registration / profile update and the FullSwing `custom:handedness` JWT
   * claim at provisioning.
   *
   * @generated from field: string handedness = 33;
   */
  handedness: string;

  /**
   * The player's current maximum USD wager in cents, from the
   * smg_bet_max_amount shot-count ladder composed with any per-user
   * override_max_bet_amount — the same bounds the AcceptBet gate
   * enforces (store.GetBetAmountBounds semantics, USD-scoped like
   * smg-core GetUser.maxShotAmount, which this supersedes as the live
   * mid-session source).
   *
   * Streamed so clients learn about a bet-amount unlock (shot_count
   * crossing a ladder tier) WITHOUT re-polling GetUser: the kiosk app
   * fires its "Level Up" popup and unlocks Shot Amount options off
   * this field's transitions, and the simulator renders the active
   * player's max next to their balance.
   *
   * 0 = not populated (older server, or the bounds read failed at
   * snapshot time — the pass is best-effort like skill_index).
   * Consumers must treat 0 as "unknown", never as "no bets allowed".
   *
   * @generated from field: int64 usd_max_wager_cents = 34;
   */
  usdMaxWagerCents: bigint;

  /**
   * SMG-3823: the engine's stored per-user autoplay PREFERENCE, projected
   * from engine smg_user_details via BetEngine.GetUserDetails at snapshot
   * build. Distinct from auto_continue_wager_cents (bay-session's OWN pin,
   * which is write-through to the engine, so THIS projection is always
   * fresher-or-equal and is the display source of truth).
   *
   * Message field => presence-tracked; nil means UNKNOWN (old backend /
   * engine unreachable / per-user miss). Consumers MUST keep their
   * previous value on nil.
   *
   * @generated from field: evenplay.bay_session.v1.EngineAutoPlayPreference engine_auto_play = 35;
   */
  engineAutoPlay?: EngineAutoPlayPreference;
};

/**
 * Describes the message evenplay.bay_session.v1.SessionPlayer.
 * Use `create(SessionPlayerSchema)` to create a new message.
 */
export const SessionPlayerSchema: GenMessage<SessionPlayer> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 4);

/**
 * PlayerWager — one bay_session_wagers row projected onto the wire
 * (SMG-3138 v1.1 B2). Mirrors the substrate landed by SMG-3137 (B1);
 * see store.BaySessionWager for the per-field docstrings on the
 * storage side.
 *
 * @generated from message evenplay.bay_session.v1.PlayerWager
 */
export type PlayerWager = Message<"evenplay.bay_session.v1.PlayerWager"> & {
  /**
   * Wallet currency identifier. UPPERCASE per the smg_bet.currency
   * convention enforced by the bay_session_wagers CHECK constraint
   * (USD / TGPTS / FSPTS / PRACTICE / ...). The category enum
   * (WagerMode: MONEY / POINTS / PRACTICE) is derived from currency at
   * the read site (eligibility.CurrencyToWagerMode); the wire here
   * carries the wallet-side identifier.
   *
   * @generated from field: string currency = 1;
   */
  currency: string;

  /**
   * smg_bet.bet_id stringified for forward-compat with the future
   * bet_id int64 → UUID migration (matches AcceptBetResponse.bet_id /
   * SessionPlayer.active_bet_id which already string-encode the id).
   *
   * Empty string when the wager is mid-teeup: the kiosk has allocated
   * the bay_session_wagers row but engine has not yet minted the
   * smg_bet row (the "accepted" state, NULL bet_id column). The
   * StartHit CAS transition writes the bet_id alongside the
   * accepted -> committed flip; the next snapshot then carries a
   * populated bet_id.
   *
   * @generated from field: string bet_id = 2;
   */
  betId: string;

  /**
   * Per-wager lifecycle state — one of {"accepted", "committed",
   * "settling", "closed"}. Mirrors bay_session_wagers.bet_state
   * (store.BetState). Deliberately a narrower vocabulary than
   * smg_bet.bet_state: the wager row tracks "is this allocation still
   * live at this station?" while smg_bet.bet_state carries the
   * settlement-outcome subtype (settled / refunded / cancelled /
   * declined / recovery_failed). The terminal wager state is
   * "closed" regardless of outcome subtype; the actual outcome lives
   * on smg_bet.outcome.
   *
   * @generated from field: string bet_state = 3;
   */
  betState: string;

  /**
   * Wager amount in minor units of currency (cents for USD, 1:1 for
   * points currencies such as TGPTS / FSPTS). Mirrors
   * bay_session_wagers.amount.
   *
   * @generated from field: int64 amount = 4;
   */
  amount: bigint;

  /**
   * Cents-of-multiplier; 100 = 1.0x, 300 = 3.0x. Mirrors
   * bay_session_wagers.multiplier_cents.
   *
   * 0 when the wager is pre-settlement (the multiplier_cents column is
   * NULL until engine flips the bet from committed -> settling and
   * writes the canonical multiplier). The 0-vs-NULL distinction at
   * the storage layer is preserved on store.BaySessionWager.
   * MultiplierCents (a *int32) so writers can tell a deliberate
   * zero-multiplier settle (theoretical: every settled bet today has
   * a non-zero multiplier) from "not yet settled"; on the wire the
   * proto3 default collapses both to 0.
   *
   * @generated from field: int64 multiplier = 5;
   */
  multiplier: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.PlayerWager.
 * Use `create(PlayerWagerSchema)` to create a new message.
 */
export const PlayerWagerSchema: GenMessage<PlayerWager> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 5);

/**
 * RotationState — turn state for ROTATION mode.
 *
 * @generated from message evenplay.bay_session.v1.RotationState
 */
export type RotationState = Message<"evenplay.bay_session.v1.RotationState"> & {
  /**
   * @generated from field: int64 current_player_id = 1;
   */
  currentPlayerId: bigint;

  /**
   * @generated from field: int64 next_player_id = 2;
   */
  nextPlayerId: bigint;

  /**
   * advisory; resets on pod restart
   *
   * @generated from field: int32 shots_taken = 3;
   */
  shotsTaken: number;

  /**
   * @generated from field: int32 shots_remaining = 4;
   */
  shotsRemaining: number;

  /**
   * @generated from field: int32 shots_per_turn = 5;
   */
  shotsPerTurn: number;

  /**
   * @generated from field: bool turn_complete = 6;
   */
  turnComplete: boolean;

  /**
   * @generated from field: repeated int64 player_order = 7;
   */
  playerOrder: bigint[];

  /**
   * @generated from field: bool awaiting_confirmation = 8;
   */
  awaitingConfirmation: boolean;

  /**
   * @generated from field: int32 timeout_seconds = 9;
   */
  timeoutSeconds: number;
};

/**
 * Describes the message evenplay.bay_session.v1.RotationState.
 * Use `create(RotationStateSchema)` to create a new message.
 */
export const RotationStateSchema: GenMessage<RotationState> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 6);

/**
 * FrsUpdate — single FRS detection frame pushed by the simulator's webcam
 * pipeline via PushFrsUpdate (client-streaming). Field numbers preserved
 * from smg_service.proto StationWebcamUpdate for wire compatibility with
 * the dual-write shim.
 *
 * @generated from message evenplay.bay_session.v1.FrsUpdate
 */
export type FrsUpdate = Message<"evenplay.bay_session.v1.FrsUpdate"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp send_time = 2;
   */
  sendTime?: Timestamp;

  /**
   * @generated from field: repeated evenplay.bay_session.v1.FrsWebcamState webcam_state = 3;
   */
  webcamState: FrsWebcamState[];

  /**
   * @generated from field: string token = 4;
   */
  token: string;

  /**
   * @generated from field: string frs_track_id = 5;
   */
  frsTrackId: string;

  /**
   * @generated from field: string frs_identification_key = 6;
   */
  frsIdentificationKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.FrsUpdate.
 * Use `create(FrsUpdateSchema)` to create a new message.
 */
export const FrsUpdateSchema: GenMessage<FrsUpdate> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 7);

/**
 * FrsWebcamState — per-camera frame from FrsUpdate.
 *
 * @generated from message evenplay.bay_session.v1.FrsWebcamState
 */
export type FrsWebcamState = Message<"evenplay.bay_session.v1.FrsWebcamState"> & {
  /**
   * @generated from field: string webcam_id = 1;
   */
  webcamId: string;

  /**
   * @generated from field: google.protobuf.Timestamp capture_time = 2;
   */
  captureTime?: Timestamp;

  /**
   * @generated from field: bool face_detected = 3;
   */
  faceDetected: boolean;

  /**
   * @generated from field: int64 user_id = 4;
   */
  userId: bigint;

  /**
   * @generated from field: float probability = 5;
   */
  probability: number;

  /**
   * @generated from field: bool multiple_human_detected = 6;
   */
  multipleHumanDetected: boolean;

  /**
   * @generated from field: int32 number_of_human_detected = 7;
   */
  numberOfHumanDetected: number;

  /**
   * @generated from field: evenplay.bay_session.v1.FrsWebcamState.Side side = 8;
   */
  side: FrsWebcamState_Side;

  /**
   * @generated from field: int32 number_of_human_in_detectable_area = 9;
   */
  numberOfHumanInDetectableArea: number;

  /**
   * @generated from field: int64 user_id_in_detectable_area = 10;
   */
  userIdInDetectableArea: bigint;

  /**
   * @generated from field: bool face_detected_in_detectable_area = 11;
   */
  faceDetectedInDetectableArea: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.FrsWebcamState.
 * Use `create(FrsWebcamStateSchema)` to create a new message.
 */
export const FrsWebcamStateSchema: GenMessage<FrsWebcamState> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 8);

/**
 * @generated from enum evenplay.bay_session.v1.FrsWebcamState.Side
 */
export enum FrsWebcamState_Side {
  /**
   * @generated from enum value: SIDE_UNSPECIFIED = 0;
   */
  SIDE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: LEFT = 1;
   */
  LEFT = 1,

  /**
   * @generated from enum value: RIGHT = 2;
   */
  RIGHT = 2,
}

/**
 * Describes the enum evenplay.bay_session.v1.FrsWebcamState.Side.
 */
export const FrsWebcamState_SideSchema: GenEnum<FrsWebcamState_Side> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 8, 0);

/**
 * Heartbeat — published by each pod every 10s per owned subject.
 * Subscribers reconnect if 30s elapse with no message of any kind.
 *
 * @generated from message evenplay.bay_session.v1.Heartbeat
 */
export type Heartbeat = Message<"evenplay.bay_session.v1.Heartbeat"> & {
  /**
   * most recently emitted sequence for this subject
   *
   * @generated from field: int64 sequence = 1;
   */
  sequence: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp sent_at = 2;
   */
  sentAt?: Timestamp;

  /**
   * SMG-4191: the causal position of the most recent STATE frame emitted on
   * this stream, in the currency consumers actually dedupe with — the
   * BSA-FU-XPOD-ORDERING db_version plus the SMG-3390 sub_sequence
   * tiebreaker — rather than the broker sequence echoed above. An idle
   * subscriber compares its applied watermark against this echo: a
   * heartbeat db_version ahead of what it holds means it LOST a frame this
   * stream did emit (client-side drop or transport loss), so it should do
   * one GetSessionState resync instead of polling on a timer.
   *
   * Presence rule: the echo is populated once the stream has emitted a
   * watermarked state frame; until then (a replay-path resume before the
   * first live frame, or an out-of-session snapshot) all three fields are 0.
   * Consumers gate on `db_version != 0 && station_id != 0` — NEVER on
   * sub_sequence: (V, 0, S) is a valid echo and the normal shape after the
   * initial snapshot or a re-snapshot, whose wire sub_sequence is 0. Frames
   * carrying no db_version (legacy producers) or no station (station-0
   * leave frames) never move the echo, so once populated it never regresses
   * to "no information".
   *
   * station_id is the single station slot: the station whose db_version
   * counter the echo belongs to (db_version is a PER-STATION counter —
   * BSF-H11). A station stream always reports its own station; a player
   * stream follows its subject, so the slot changes as the subject moves.
   *
   * Scope: only direct BaySessionService stream subscribers receive this
   * echo. The legacy core relay (SmgService.StreamStationState,
   * apps/platform-domain/core/cmd/smg/station.go) drops heartbeat frames
   * before forwarding, so clients behind it see neither the liveness frame
   * nor the watermark.
   *
   * Known limitation: a lost frame at the SAME db_version as a snapshot the
   * client already applied is not detectable from this echo, because
   * consumers seed their sub_sequence baseline to the max sentinel on
   * snapshots (SMG-3390). Today that class is capability-only (SMG-3837).
   *
   * db_version of the last emitted state frame
   *
   * @generated from field: int64 db_version = 3;
   */
  dbVersion: bigint;

  /**
   * its within-db_version tiebreaker, wire value (SMG-3390)
   *
   * @generated from field: int64 sub_sequence = 4;
   */
  subSequence: bigint;

  /**
   * station the watermark belongs to (player streams follow the subject across stations); 0 = none
   *
   * @generated from field: int64 station_id = 5;
   */
  stationId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.Heartbeat.
 * Use `create(HeartbeatSchema)` to create a new message.
 */
export const HeartbeatSchema: GenMessage<Heartbeat> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 9);

/**
 * ── Per-player state snapshot ─────────────────────────────────────────────
 *
 * PlayerState is the privacy-scoped per-user view delivered on
 * bay_session.state.player.{user_id}. It contains ONLY the data the subject
 * user is entitled to see: their own session_player projection plus the
 * containing station's id/play_mode/timestamp. Other players' wallet/preview
 * data MUST never appear here — the privacy boundary is the publish
 * boundary, and the wire-level subject scoping (one subject per user) is
 * the second line of defence.
 *
 * funds is reserved for the BSA-6-x wallet integration; nil until that
 * epic lands. The field number is sized high so the SessionPlayer-style
 * "future numbers stay in the low range" convention holds.
 *
 * @generated from message evenplay.bay_session.v1.PlayerState
 */
export type PlayerState = Message<"evenplay.bay_session.v1.PlayerState"> & {
  /**
   * smg_user.user_id — the int64 identity of the subject user. Mirrors
   * the SessionPlayer.user_id field.
   *
   * @generated from field: int64 user_id = 1;
   */
  userId: bigint;

  /**
   * Station the user is currently in; 0 when the user is not in any
   * station's roster. The subject user can correlate this with the
   * SessionState they receive on bay_session.state.station.{station_id}.
   *
   * @generated from field: int64 current_station_id = 2;
   */
  currentStationId: bigint;

  /**
   * Privacy-scoped per-player projection — same shape as the
   * SessionState.players[] entry for this user. Other players' rows are
   * never included on this subject.
   *
   * @generated from field: evenplay.bay_session.v1.SessionPlayer session_player = 3;
   */
  sessionPlayer?: SessionPlayer;

  /**
   * play_mode of the containing station. Useful for UI gating without
   * requiring a second subscription.
   *
   * @generated from field: evenplay.bay_session.v1.SessionPlayMode station_play_mode = 4;
   */
  stationPlayMode: SessionPlayMode;

  /**
   * Server clock when the snapshot was assembled. Independent of
   * PlayerStateUpdate.sequence; helpful for UI staleness checks.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * BSA-4-4 stream parity (mobile-side). Three derived fields surfaced
   * so the skillstrike-mobile client can retire its second subscription
   * to PartnerKioskUpdatesStream. All three are read-side projections
   * of state already on this snapshot — no new persistence.
   *
   * user_session_state: membership classifier (NOT_JOINED / NOT_ACTIVE /
   *   ACTIVE). NOT_JOINED when the subject is in no roster. A joined subject
   *   with session_player.is_idle=true is NOT_ACTIVE in every mode. Account
   *   and guardian confirmation gates do not change membership. Otherwise
   *   OPEN/SOLO participants are ACTIVE and other modes use the active-player
   *   pointer rule.
   *
   * @generated from field: evenplay.bay_session.v1.UserSessionState user_session_state = 6;
   */
  userSessionState: UserSessionState;

  /**
   * is_session_full: true iff the containing station's roster is at its
   *   max_players ceiling. Derived from len(SessionState.players) and
   *   station_capabilities.max_players at the publish/snapshot site.
   *   false when the station's capacity is unknown (capabilities row
   *   unprovisioned) — the field is defensive UX gating, not a hard
   *   security barrier; JoinSession itself enforces the cap.
   *
   * @generated from field: bool is_session_full = 7;
   */
  isSessionFull: boolean;

  /**
   * account_security_bypass_enabled: per-player mobile-confirmation
   *   bypass. Derived from session_player.confirmation.on_shot: an
   *   explicit false means "skip the mobile-side accept dialog before
   *   each shot" (account_security_bypass_enabled=true). nil or true
   *   confirmation.on_shot leaves the bypass disabled. Mirrors the
   *   legacy partner-service UserSessionUpdateData.
   *   account_security_bypass_enabled.
   *
   * @generated from field: bool account_security_bypass_enabled = 8;
   */
  accountSecurityBypassEnabled: boolean;

  /**
   * db_version mirrors SessionState.db_version — the containing
   * station's strict-monotonic version counter (BSA-FU-PANEL-XPOD-4).
   * Per-player publishes derive this from the same
   * bay_session_state.db_version that drove the SessionState publish, so
   * a subscriber watching both station and player streams sees both
   * channels advance against the same monotonic source. 0 = unstamped
   * (pre-XPOD-4 producer or freshly-migrated row); consumers retain 0
   * and order that frame by broker sequence until the first mutation
   * establishes a positive station counter.
   *
   * @generated from field: int64 db_version = 9;
   */
  dbVersion: bigint;

  /**
   * awaiting_confirmation: true iff the subject IS the non-idle active player
   * AND the station is awaiting that player's turn confirmation. Projected
   * per-subject from the rotation block (is_active && !is_idle &&
   * SessionState.rotation.awaiting_confirmation) in ROTATION, or from the
   * AWAITING player_select_confirmation projection in OPEN play (OPEN-play
   * turn confirmation: SetActivePlayer arms the same persisted gate on an
   * active-player switch to a confirm_on_turn player). It is the single
   * authoritative "you must tap Start Playing! before you can shoot"
   * signal — the mobile client triggers the turn-confirmation modal off this
   * instead of inferring it from play_mode + user_session_state, which fires
   * for every idle rotation player (SMG-3031 defect: modal popped out of turn).
   * false for non-active or timeout-locked players, SOLO/EVENT/FRS modes, and
   * after the player confirms (RespondToConfirmation clears
   * awaiting_confirmation).
   *
   * @generated from field: bool awaiting_confirmation = 10;
   */
  awaitingConfirmation: boolean;

  /**
   * SMG-3061: first name of the station's current active player (the
   * user at active_user_id). Surfaced on the per-user PlayerState
   * projection so a NOT_ACTIVE player can render "Diana is currently
   * playing" without subscribing to the per-station SessionState
   * stream (which would also leak other players' wallet/bet data).
   * Empty string when there is no gameplay-active user (SOLO/OPEN with nobody
   * designated, a timeout-locked bookkeeping pointer, or a rotation gap
   * between turns). The first_name field is
   * identity-adjacent and non-sensitive — already shown on the kiosk's
   * shared display.
   *
   * @generated from field: string active_player_first_name = 11;
   */
  activePlayerFirstName: string;

  /**
   * SMG-3117: rotation summary projected from the station's
   * SessionState.rotation, surfaced per-subject so the mobile client
   * can render the rotation panel (PLAYER ORDER, "Shot N of M", "Up
   * next", per-player shots-until-turn countdown) without
   * subscribing to the per-station SessionState stream — which would
   * leak other players' wallet / bet / autoplay projections to the
   * mobile per-user surface.
   *
   * Non-nil only when station_play_mode = ROTATION. Carries the same
   * RotationState the kiosk reads off SessionState — current /
   * next / shots_taken / shots_remaining / shots_per_turn /
   * turn_complete / player_order / awaiting_confirmation /
   * timeout_seconds. nil for non-ROTATION modes (the consumer
   * collapses the rotation panel when nil — same behavior as a
   * SessionState consumer seeing state.rotation = nil).
   *
   * @generated from field: evenplay.bay_session.v1.RotationState rotation = 12;
   */
  rotation?: RotationState;

  /**
   * SMG-3117: display-name map keyed by user_id for every player in
   * rotation.player_order. Identity-adjacent (first_name only — same
   * surface SessionPlayer.first_name already exposes for the
   * subject's own row and active_player_first_name exposes for the
   * active player). Lets the rotation-panel projector resolve every
   * slot to a display name without a second roster lookup.
   *
   * Empty map outside ROTATION mode OR when the station has no
   * roster. Same lifecycle as `rotation` — populated by the
   * server-side projector that builds the snapshot.
   *
   * @generated from field: map<int64, string> rotation_participant_names = 13;
   */
  rotationParticipantNames: { [key: string]: string };

  /**
   * SMG-3481: per-shot arm state, mirrored from the station-level
   * SessionState.shot_armed_bet_id (field 25) onto the per-subject
   * projection so the mobile app can render the per-shot confirm
   * affordance from server truth instead of a local latch. The stringified
   * bet_id the per-shot confirmation handshake has armed for the active
   * player; empty when no shot is armed (autoplay, or a confirm-on-shot
   * player who has not yet tapped Confirm in the app). A shot is armed for
   * the subject's active bet iff shot_armed_bet_id == session_player.active_bet_id.
   * Cleared by ProcessShot's CommitAcceptedBet CAS, so it re-requires a
   * confirm per shot. Survives a mobile reload (server-authoritative).
   *
   * @generated from field: string shot_armed_bet_id = 14;
   */
  shotArmedBetId: string;

  /**
   * TRN-BSA: one-shot tournament join prompt. Non-nil ONLY on the single
   * publish that first offers a tournament to this subject player
   * (triggered when a peer enters TOURNAMENT mode, per TRN-7) — it is
   * NOT a level-triggered "an offer is outstanding" flag. The producer
   * sets it on exactly that one publish and leaves it nil on every
   * subsequent publish (including resyncs and the publishes after the
   * player accepts or declines), so a consumer reacts to the EDGE: show
   * the join pop-up when the field appears, and never re-derive standing
   * offer state from it. Carries tournament_id only; name/images come
   * from TRN-1's metadata RPC (see TournamentJoinOffer). nil in every
   * non-TOURNAMENT context. Accompanied by reason
   * PLAYER_TOURNAMENT_JOIN_OFFERED on the PlayerStateUpdate envelope.
   * Renumbered 14->15 on the main merge: SMG-3481 claimed field 14.
   *
   * @generated from field: evenplay.bay_session.v1.TournamentJoinOffer tournament_join_offer = 15;
   */
  tournamentJoinOffer?: TournamentJoinOffer;

  /**
   * Player-scoped notification messages currently active for this subject
   * (SMG-3330). Projected by bay-session from its NotificationService
   * subscription: messages targeted at this user plus active broadcasts.
   * Privacy-scoped to the subject — other players' messages are never
   * included on this per-user subject. Empty when no messages are active
   * or the projection is unwired. The authoritative store is
   * NotificationService; this is a read-side projection carried on the
   * existing snapshot.
   *
   * @generated from field: repeated evenplay.notification.v1.Message active_messages = 16;
   */
  activeMessages: Message$1[];

  /**
   * Currency-by-currency wallet availability. Reserved for BSA-6-x; the
   * bay-session pod publishes nil here until that epic wires the
   * wallet projection.
   *
   * @generated from field: repeated evenplay.bay_session.v1.CurrencyAvailability funds = 100;
   */
  funds: CurrencyAvailability[];
};

/**
 * Describes the message evenplay.bay_session.v1.PlayerState.
 * Use `create(PlayerStateSchema)` to create a new message.
 */
export const PlayerStateSchema: GenMessage<PlayerState> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 10);

/**
 * CurrencyAvailability — per-currency liquidity snapshot delivered inside
 * PlayerState.funds. Mirrors the wallet domain's balance breakdown.
 *
 * available: balance the user can spend on a new wager right now (in
 * minor units — cents for USD, 1:1 for points currencies such as
 * TGPTS / FSPTS).
 * locked: balance reserved by in-flight bets / pending settlement.
 *
 * Reserved for BSA-6-x; the bay-session pod publishes nil for the whole
 * funds list until that epic wires the wallet projection.
 *
 * TOURNAMENT_PTS currency convention (TRN-BSA): when the bay is in
 * SESSION_PLAY_MODE_TOURNAMENT the snapshot builder appends a
 * DISPLAY-ONLY CurrencyAvailability entry with currency="TOURNAMENT_PTS"
 * carrying the active player's tournament score in `available`. This
 * follows the PRACTICE-mode precedent — it is NOT a wallet balance: no
 * wallet RPC backs it, `locked` is always 0, and minor units are 1:1
 * with the tournament score (no cents scaling, unlike USD). The entry
 * is absent entirely outside TOURNAMENT mode. Producers/consumers that
 * route real wagers MUST ignore TOURNAMENT_PTS the same way they ignore
 * the PRACTICE display currency.
 *
 * @generated from message evenplay.bay_session.v1.CurrencyAvailability
 */
export type CurrencyAvailability = Message<"evenplay.bay_session.v1.CurrencyAvailability"> & {
  /**
   * @generated from field: string currency = 1;
   */
  currency: string;

  /**
   * @generated from field: int64 available = 2;
   */
  available: bigint;

  /**
   * @generated from field: int64 locked = 3;
   */
  locked: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.CurrencyAvailability.
 * Use `create(CurrencyAvailabilitySchema)` to create a new message.
 */
export const CurrencyAvailabilitySchema: GenMessage<CurrencyAvailability> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 11);

/**
 * TournamentStandingEntry — one row of a tournament leaderboard
 * (TRN-BSA). Mirrors the PlayerStanding shape TRN-1's standings RPC
 * returns. Carried on ProcessShotResponse.leaderboard (see
 * simulator_bay_session.proto) so the simulator can re-render standings
 * after each shot WITHOUT a second RPC; populated only when the bay is
 * in SESSION_PLAY_MODE_TOURNAMENT.
 *
 * @generated from message evenplay.bay_session.v1.TournamentStandingEntry
 */
export type TournamentStandingEntry = Message<"evenplay.bay_session.v1.TournamentStandingEntry"> & {
  /**
   * 1-based finishing position within the tournament. Ties are resolved
   * by the standings source (TRN-1); the wire surface carries whatever
   * rank that source assigns.
   *
   * @generated from field: int32 rank = 1;
   */
  rank: number;

  /**
   * smg_user.user_id of the ranked player.
   *
   * @generated from field: int64 user_id = 2;
   */
  userId: bigint;

  /**
   * Display name of the ranked player. Identity-adjacent (same surface
   * SessionPlayer.first_name / active_player_first_name already expose);
   * no wallet or PII beyond the name.
   *
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * The player's tournament score. Minor units are 1:1 with the
   * tournament score (the same convention TOURNAMENT_PTS uses on
   * CurrencyAvailability) — there is no cents scaling.
   *
   * @generated from field: int64 score = 4;
   */
  score: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentStandingEntry.
 * Use `create(TournamentStandingEntrySchema)` to create a new message.
 */
export const TournamentStandingEntrySchema: GenMessage<TournamentStandingEntry> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 12);

/**
 * TournamentJoinOffer — the join-prompt payload carried on
 * PlayerState.tournament_join_offer (TRN-BSA). Deliberately carries the
 * tournament_id ONLY: the simulator/client pulls the tournament's
 * immutable-during-play metadata (name, images) ONCE via TRN-1's
 * metadata RPC and caches it, so that data is never pushed per-publish.
 * Do NOT add name/image fields here — that would defeat the
 * pull-once-and-cache design.
 *
 * @generated from message evenplay.bay_session.v1.TournamentJoinOffer
 */
export type TournamentJoinOffer = Message<"evenplay.bay_session.v1.TournamentJoinOffer"> & {
  /**
   * The tournament being offered to the subject player. Always non-zero
   * when this message is present (presence of the message IS the offer).
   *
   * @generated from field: int64 tournament_id = 1;
   */
  tournamentId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.TournamentJoinOffer.
 * Use `create(TournamentJoinOfferSchema)` to create a new message.
 */
export const TournamentJoinOfferSchema: GenMessage<TournamentJoinOffer> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 13);

/**
 * @generated from message evenplay.bay_session.v1.AckMessageRequest
 */
export type AckMessageRequest = Message<"evenplay.bay_session.v1.AckMessageRequest"> & {
  /**
   * message_id of the notification message to acknowledge. This is the
   * ONLY input: bay-session looks the message up in its own projection
   * and derives the ack scope and acked_by/source from the message and
   * the caller's token — the client cannot widen its own authorization
   * by supplying extra scope fields.
   *
   * @generated from field: string message_id = 1;
   */
  messageId: string;
};

/**
 * Describes the message evenplay.bay_session.v1.AckMessageRequest.
 * Use `create(AckMessageRequestSchema)` to create a new message.
 */
export const AckMessageRequestSchema: GenMessage<AckMessageRequest> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 14);

/**
 * Intentionally empty: the ack is confirmed by a successful response,
 * and the updated active_messages projection arrives on the caller's
 * existing PlayerState / SessionState stream. Extensible later without
 * a wire break.
 *
 * @generated from message evenplay.bay_session.v1.AckMessageResponse
 */
export type AckMessageResponse = Message<"evenplay.bay_session.v1.AckMessageResponse"> & {
};

/**
 * Describes the message evenplay.bay_session.v1.AckMessageResponse.
 * Use `create(AckMessageResponseSchema)` to create a new message.
 */
export const AckMessageResponseSchema: GenMessage<AckMessageResponse> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 15);

/**
 * @generated from message evenplay.bay_session.v1.LeaveSessionRequest
 */
export type LeaveSessionRequest = Message<"evenplay.bay_session.v1.LeaveSessionRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 user_id = 2;
   */
  userId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.LeaveSessionRequest.
 * Use `create(LeaveSessionRequestSchema)` to create a new message.
 */
export const LeaveSessionRequestSchema: GenMessage<LeaveSessionRequest> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 16);

/**
 * @generated from message evenplay.bay_session.v1.LeaveSessionResponse
 */
export type LeaveSessionResponse = Message<"evenplay.bay_session.v1.LeaveSessionResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionState session = 1;
   */
  session?: SessionState;
};

/**
 * Describes the message evenplay.bay_session.v1.LeaveSessionResponse.
 * Use `create(LeaveSessionResponseSchema)` to create a new message.
 */
export const LeaveSessionResponseSchema: GenMessage<LeaveSessionResponse> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 17);

/**
 * @generated from message evenplay.bay_session.v1.GetSessionStateRequest
 */
export type GetSessionStateRequest = Message<"evenplay.bay_session.v1.GetSessionStateRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.GetSessionStateRequest.
 * Use `create(GetSessionStateRequestSchema)` to create a new message.
 */
export const GetSessionStateRequestSchema: GenMessage<GetSessionStateRequest> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 18);

/**
 * @generated from message evenplay.bay_session.v1.GetSessionStateResponse
 */
export type GetSessionStateResponse = Message<"evenplay.bay_session.v1.GetSessionStateResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionState state = 1;
   */
  state?: SessionState;
};

/**
 * Describes the message evenplay.bay_session.v1.GetSessionStateResponse.
 * Use `create(GetSessionStateResponseSchema)` to create a new message.
 */
export const GetSessionStateResponseSchema: GenMessage<GetSessionStateResponse> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 19);

/**
 * @generated from message evenplay.bay_session.v1.StreamSessionStateRequest
 */
export type StreamSessionStateRequest = Message<"evenplay.bay_session.v1.StreamSessionStateRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * optional; 0 = full snapshot
   *
   * @generated from field: int64 since_sequence = 2;
   */
  sinceSequence: bigint;

  /**
   * since_db_version is the last causal watermark the client previously
   * delivered to the application (epoch microseconds of the producing
   * pod's bay_session_state.updated_at — see SessionStateUpdate.db_version).
   * BSA-FU-PANEL-XPOD-2 (2026-05-21): the consumer-side stale-frame
   * suppression keys on db_version, so a reconnect that only carries
   * since_sequence would seed the server's dedup baseline at 0 and let
   * any cross-pod-reordered older-causal frame past the resume point
   * overwrite fresher state on the client. Supplying since_db_version
   * together with a positive since_sequence enables the broker-seq
   * replay optimisation; omitting it (or sending 0) forces the
   * server back through a fresh snapshot so the causal baseline is
   * reconstructed from the DB.
   *
   * @generated from field: int64 since_db_version = 3;
   */
  sinceDbVersion: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.StreamSessionStateRequest.
 * Use `create(StreamSessionStateRequestSchema)` to create a new message.
 */
export const StreamSessionStateRequestSchema: GenMessage<StreamSessionStateRequest> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 20);

/**
 * @generated from message evenplay.bay_session.v1.SetPlayerConfirmationSettingsRequest
 */
export type SetPlayerConfirmationSettingsRequest = Message<"evenplay.bay_session.v1.SetPlayerConfirmationSettingsRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * @generated from field: int64 user_id = 2;
   */
  userId: bigint;

  /**
   * @generated from field: evenplay.bay_session.v1.ConfirmationSettings settings = 3;
   */
  settings?: ConfirmationSettings;
};

/**
 * Describes the message evenplay.bay_session.v1.SetPlayerConfirmationSettingsRequest.
 * Use `create(SetPlayerConfirmationSettingsRequestSchema)` to create a new message.
 */
export const SetPlayerConfirmationSettingsRequestSchema: GenMessage<SetPlayerConfirmationSettingsRequest> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 21);

/**
 * @generated from message evenplay.bay_session.v1.SetPlayerConfirmationSettingsResponse
 */
export type SetPlayerConfirmationSettingsResponse = Message<"evenplay.bay_session.v1.SetPlayerConfirmationSettingsResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionPlayer player = 1;
   */
  player?: SessionPlayer;
};

/**
 * Describes the message evenplay.bay_session.v1.SetPlayerConfirmationSettingsResponse.
 * Use `create(SetPlayerConfirmationSettingsResponseSchema)` to create a new message.
 */
export const SetPlayerConfirmationSettingsResponseSchema: GenMessage<SetPlayerConfirmationSettingsResponse> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 22);

/**
 * SetNextWagerCurrencyRequest carries the station and the wallet currency
 * token the caller's NEXT wager should draw from. The server derives the
 * matching wager_mode from the currency via venue_partner config and
 * writes both to bay_session_players.
 *
 * @generated from message evenplay.bay_session.v1.SetNextWagerCurrencyRequest
 */
export type SetNextWagerCurrencyRequest = Message<"evenplay.bay_session.v1.SetNextWagerCurrencyRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * Wallet currency token the next wager draws from (USD / TGPTS /
   * FSPTS / PRACTICE). Written to bay_session_players.next_wager_currency;
   * the wager_mode category is derived server-side.
   *
   * @generated from field: string currency = 2;
   */
  currency: string;

  /**
   * Client-supplied idempotency key (UUID v4). A retry with the same
   * (caller, key) is a no-op success returning the current snapshot.
   *
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.SetNextWagerCurrencyRequest.
 * Use `create(SetNextWagerCurrencyRequestSchema)` to create a new message.
 */
export const SetNextWagerCurrencyRequestSchema: GenMessage<SetNextWagerCurrencyRequest> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 23);

/**
 * SetNextWagerCurrencyResponse returns the updated SessionPlayer snapshot
 * carrying the new next_wager_currency + derived wager_mode.
 *
 * @generated from message evenplay.bay_session.v1.SetNextWagerCurrencyResponse
 */
export type SetNextWagerCurrencyResponse = Message<"evenplay.bay_session.v1.SetNextWagerCurrencyResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionPlayer player = 1;
   */
  player?: SessionPlayer;
};

/**
 * Describes the message evenplay.bay_session.v1.SetNextWagerCurrencyResponse.
 * Use `create(SetNextWagerCurrencyResponseSchema)` to create a new message.
 */
export const SetNextWagerCurrencyResponseSchema: GenMessage<SetNextWagerCurrencyResponse> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 24);

/**
 * SwitchWagerCurrencyRequest carries the station and the currency to move
 * the caller's CURRENT open wager into. The handler cancels the existing
 * bet and re-mints an equivalent one in target_currency (SMG-3443/SMG-3444).
 *
 * @generated from message evenplay.bay_session.v1.SwitchWagerCurrencyRequest
 */
export type SwitchWagerCurrencyRequest = Message<"evenplay.bay_session.v1.SwitchWagerCurrencyRequest"> & {
  /**
   * @generated from field: int64 station_id = 1;
   */
  stationId: bigint;

  /**
   * Wallet currency token (USD / TGPTS / FSPTS / PRACTICE) to re-mint the
   * open wager into.
   *
   * @generated from field: string target_currency = 2;
   */
  targetCurrency: string;

  /**
   * Client-supplied idempotency key (UUID v4). A retry with the same
   * (caller, key) returns the existing re-mint result.
   *
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;
};

/**
 * Describes the message evenplay.bay_session.v1.SwitchWagerCurrencyRequest.
 * Use `create(SwitchWagerCurrencyRequestSchema)` to create a new message.
 */
export const SwitchWagerCurrencyRequestSchema: GenMessage<SwitchWagerCurrencyRequest> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 25);

/**
 * SwitchWagerCurrencyResponse returns the post-switch SessionPlayer
 * snapshot plus the before/after currency and whether a re-mint actually
 * occurred.
 *
 * @generated from message evenplay.bay_session.v1.SwitchWagerCurrencyResponse
 */
export type SwitchWagerCurrencyResponse = Message<"evenplay.bay_session.v1.SwitchWagerCurrencyResponse"> & {
  /**
   * @generated from field: evenplay.bay_session.v1.SessionPlayer player = 1;
   */
  player?: SessionPlayer;

  /**
   * The currency the open wager was in before the switch.
   *
   * @generated from field: string previous_currency = 2;
   */
  previousCurrency: string;

  /**
   * The currency the wager is in after the switch (== target_currency on
   * success).
   *
   * @generated from field: string new_currency = 3;
   */
  newCurrency: string;

  /**
   * True when the bet was actually cancelled + re-minted; false when the
   * bet was already in target_currency (a no-op success).
   *
   * @generated from field: bool reminted = 4;
   */
  reminted: boolean;
};

/**
 * Describes the message evenplay.bay_session.v1.SwitchWagerCurrencyResponse.
 * Use `create(SwitchWagerCurrencyResponseSchema)` to create a new message.
 */
export const SwitchWagerCurrencyResponseSchema: GenMessage<SwitchWagerCurrencyResponse> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 26);

/**
 * GetBetDetails — request-response RPC that surfaces the canonical
 * challenges + paylines for a single bet. Replaces the burrito-side
 * smg.GetGameState dependency for payout-ring rendering and local
 * shot-result calculation (BSA-FU-GETGAMESTATE-RPC).
 *
 * The SessionState stream already carries the bet's identity (active
 * bet_id + bet amount) on every snapshot, but does NOT carry the
 * per-challenge tiers / circle radii / payline multipliers the kiosk
 * UI needs to draw the payout ring and pre-compute the win zone for
 * the next shot. Those challenge/payline fields are derived from the
 * target distance and frozen at AcceptBet, so they are stable for the
 * life of the bet; embedding them on every per-frame snapshot would
 * bloat it (≈10× message size) for data that never changes mid-bet —
 * so they live behind this request-response RPC instead.
 *
 * bet_amount is the exception: it is NOT immutable after accept. A
 * ResizeWager (SMG-3140) changes the wager amount mid-bet, updating
 * both bay_session_wagers.amount and smg_bet.amount, and this RPC
 * projects the new value. Consumers that cache a GetBetDetails response
 * (e.g. the kiosk payout ring, whose payouts = bet_amount × multiplier)
 * MUST re-fetch when the SessionState stream reports a changed
 * active_bet_amount — do not treat this payload as immutable for the
 * life of the bet.
 *
 * Dual-hosted on PlayerBaySessionService AND SimulatorBaySessionService.
 * Same predicate as GetSessionState: RequireSimulatorOrPlayerForSession
 * against the bet's owning station. The kiosk-side simulator calls it
 * through SimulatorBaySessionService (burrito already holds the
 * simulator JWT); a future mobile-app caller would reach the player
 * listener.
 *
 * @generated from message evenplay.bay_session.v1.GetBetDetailsRequest
 */
export type GetBetDetailsRequest = Message<"evenplay.bay_session.v1.GetBetDetailsRequest"> & {
  /**
   * Server-assigned smg_bet.bet_id (string-form of the int64 PK,
   * matching AcceptBetResponse.bet_id for wire stability across the
   * future int64→UUID migration). Required. The handler parses this
   * back to int64 for the lookup; an invalid (non-numeric) value is
   * rejected with CodeInvalidArgument.
   *
   * @generated from field: string bet_id = 1;
   */
  betId: string;
};

/**
 * Describes the message evenplay.bay_session.v1.GetBetDetailsRequest.
 * Use `create(GetBetDetailsRequestSchema)` to create a new message.
 */
export const GetBetDetailsRequestSchema: GenMessage<GetBetDetailsRequest> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 27);

/**
 * @generated from message evenplay.bay_session.v1.GetBetDetailsResponse
 */
export type GetBetDetailsResponse = Message<"evenplay.bay_session.v1.GetBetDetailsResponse"> & {
  /**
   * Server-assigned smg_bet.bet_id echoed back so the caller can
   * correlate the response against the request.
   *
   * @generated from field: string bet_id = 1;
   */
  betId: string;

  /**
   * The bet's persisted lifecycle state (e.g. 'accepted', 'committed',
   * 'settling', 'closed', 'refunded'). Callers that render an active
   * bet should treat anything outside {'accepted','committed'} as
   * "no longer in play" and stop showing the payout ring.
   *
   * @generated from field: string bet_state = 2;
   */
  betState: string;

  /**
   * The bet's wager amount in minor units of currency (cents for fiat,
   * 1:1 for points). Mirrors smg_bet.amount.
   *
   * @generated from field: int64 bet_amount = 3;
   */
  betAmount: bigint;

  /**
   * The bet's currency code (the wallet identifier — e.g. "USD",
   * "TGPTS", "FSPTS", "PRACTICE"). Distinct from the bay-session
   * WagerMode category enum (NONE / MONEY / POINTS / PRACTICE):
   * currency identifies the specific wallet; WagerMode identifies the
   * user-visible category. SMG-3087.
   *
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * The smg_bet.station_id the bet is hosted on. Exposed so a caller
   * that received the response over a single-shot RPC can correlate
   * back to a particular bay (the SessionState stream already carries
   * this on every snapshot, but this RPC is request-response).
   *
   * @generated from field: int64 station_id = 5;
   */
  stationId: bigint;

  /**
   * smg_bet.user_id — the player who placed the bet. Surfaced so the
   * kiosk UI can correlate the payout-ring render against the active
   * player without a second lookup. Not used for authz on the response
   * path: a roster member can read another roster member's bet
   * (matching GetSessionState's permissive "in this bay" rule).
   *
   * @generated from field: int64 user_id = 6;
   */
  userId: bigint;

  /**
   * The challenges that back this bet, sorted ascending by sequence.
   * sequence is the innermost→outermost tier index burrito uses to
   * pair up with paylines for the payout ring.
   *
   * @generated from field: repeated evenplay.bay_session.v1.BetChallenge challenges = 7;
   */
  challenges: BetChallenge[];

  /**
   * The paylines that back this bet. Each payline references one
   * challenge by challenge_id and carries the multiplier the wallet
   * applies on settlement. Ordered by priority ASC to match
   * smg_payline.priority semantics.
   *
   * @generated from field: repeated evenplay.bay_session.v1.BetPayline paylines = 8;
   */
  paylines: BetPayline[];

  /**
   * hole_in_one_bonus_amount is the additive hole-in-one bonus the
   * player wins on a qualifying hole-in-one shot, in minor units of
   * currency (cents for fiat). Mirrors the legacy smg.Bet
   * HoleInOneBonusAmount field. Computed from the venue's
   * HoleInOneBonusStructure (matched on bet amount + target distance)
   * and FROZEN onto smg_bet at AcceptBet time; this RPC projects the
   * persisted value as a pure local read (no runtime recompute). 0 when
   * the bet is not hole-in-one eligible. The SDK adds this to the
   * base payout to display the total hole-in-one prize, so the payout
   * is derivable from this response alone (challenges + paylines +
   * hole_in_one_bonus_amount).
   *
   * @generated from field: int64 hole_in_one_bonus_amount = 9;
   */
  holeInOneBonusAmount: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.GetBetDetailsResponse.
 * Use `create(GetBetDetailsResponseSchema)` to create a new message.
 */
export const GetBetDetailsResponseSchema: GenMessage<GetBetDetailsResponse> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 28);

/**
 * BetChallenge — the subset of smg_challenge columns the kiosk UI
 * needs for payout-ring rendering. value1 = target distance from tee
 * in inches (same across challenges in a bet); value2 = win-circle
 * radius from pin in inches (differs per tier). Other smg_challenge
 * columns (challenge_state, outcome, hit_id, etc.) are intentionally
 * NOT exposed — burrito's mapBet does not consume them, and exposing
 * them would bind the wire surface to smg-core's settlement model.
 *
 * @generated from message evenplay.bay_session.v1.BetChallenge
 */
export type BetChallenge = Message<"evenplay.bay_session.v1.BetChallenge"> & {
  /**
   * @generated from field: int64 challenge_id = 1;
   */
  challengeId: bigint;

  /**
   * @generated from field: int32 sequence = 2;
   */
  sequence: number;

  /**
   * @generated from field: string challenge_type = 3;
   */
  challengeType: string;

  /**
   * Target distance from tee, in inches. The first challenge's value1
   * is what burrito uses as the "target distance" for the bet (the
   * value is the same across every tier).
   *
   * @generated from field: int64 value1 = 4;
   */
  value1: bigint;

  /**
   * Win-circle radius from pin, in inches. Differs per tier — the
   * innermost ring (smallest radius) is the highest-multiplier zone.
   *
   * @generated from field: int64 value2 = 5;
   */
  value2: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.BetChallenge.
 * Use `create(BetChallengeSchema)` to create a new message.
 */
export const BetChallengeSchema: GenMessage<BetChallenge> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 29);

/**
 * BetPayline — the subset of smg_payline columns burrito's mapBet
 * consumes. multiplier is in 1/100ths (100 = 1.0x, 300 = 3.0x).
 *
 * @generated from message evenplay.bay_session.v1.BetPayline
 */
export type BetPayline = Message<"evenplay.bay_session.v1.BetPayline"> & {
  /**
   * @generated from field: int64 payline_id = 1;
   */
  paylineId: bigint;

  /**
   * @generated from field: int64 challenge_id = 2;
   */
  challengeId: bigint;

  /**
   * @generated from field: int64 multiplier = 3;
   */
  multiplier: bigint;

  /**
   * @generated from field: int64 priority = 4;
   */
  priority: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.BetPayline.
 * Use `create(BetPaylineSchema)` to create a new message.
 */
export const BetPaylineSchema: GenMessage<BetPayline> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 30);

/**
 * EngineAutoPlayPreference — the engine's stored per-user autoplay
 * preference (SMG-3823). Normalized at the projection boundary: the
 * engine's storage sentinels (0 new-user default, -1 legacy, -2 explicit
 * use-max) never reach the wire; use_max mirrors the engine's SMG-3043
 * fill-time normalization (stored <= 0 means "use tier max").
 *
 * @generated from message evenplay.bay_session.v1.EngineAutoPlayPreference
 */
export type EngineAutoPlayPreference = Message<"evenplay.bay_session.v1.EngineAutoPlayPreference"> & {
  /**
   * engine auto_play_enabled (carried; not yet consumed by mobile)
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * stored preference <= 0 ("always play max")
   *
   * @generated from field: bool use_max = 2;
   */
  useMax: boolean;

  /**
   * > 0 pinned amount in cents; 0 iff use_max
   *
   * @generated from field: int64 pinned_cents = 3;
   */
  pinnedCents: bigint;
};

/**
 * Describes the message evenplay.bay_session.v1.EngineAutoPlayPreference.
 * Use `create(EngineAutoPlayPreferenceSchema)` to create a new message.
 */
export const EngineAutoPlayPreferenceSchema: GenMessage<EngineAutoPlayPreference> = /*@__PURE__*/
  messageDesc(file_bay_session_shared, 31);

/**
 * SessionPlayMode enumerates the valid bay-session play modes per spec §2.2.
 *
 * @generated from enum evenplay.bay_session.v1.SessionPlayMode
 */
export enum SessionPlayMode {
  /**
   * @generated from enum value: SESSION_PLAY_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_SOLO = 1;
   */
  SOLO = 1,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_OPEN = 2;
   */
  OPEN = 2,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_ROTATION = 3;
   */
  ROTATION = 3,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_FRS = 4;
   */
  FRS = 4,

  /**
   * @generated from enum value: SESSION_PLAY_MODE_EVENT = 5;
   */
  EVENT = 5,

  /**
   * SESSION_PLAY_MODE_TOURNAMENT (TRN-BSA) — player-driven tournament
   * scoring. The session enters this mode as a function of the ACTIVE
   * player: when that player has an active tournament and has cleared
   * onboarding, the bay switches to TOURNAMENT carrying their
   * tournament_id and remembering the base mode (see
   * SessionState.base_play_mode); when their tournament participation
   * completes the base mode is restored.
   *
   * DISTINCT FROM EVENT (=5): EVENT is "scheduled bay-takeover events"
   * — a whole-bay takeover scheduled out of band. TOURNAMENT is
   * player-driven tournament scoring layered transiently over whatever
   * base multi-player mode the bay was already running (solo / open /
   * rotation). The two never overlap and EVENT semantics are untouched
   * by the tournament feature.
   *
   * @generated from enum value: SESSION_PLAY_MODE_TOURNAMENT = 6;
   */
  TOURNAMENT = 6,
}

/**
 * Describes the enum evenplay.bay_session.v1.SessionPlayMode.
 */
export const SessionPlayModeSchema: GenEnum<SessionPlayMode> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 0);

/**
 * MultiPlayerMode — default behaviour when a SOLO session promotes to
 * multi-player (a second player joins). Spec §2.3.
 *
 * @generated from enum evenplay.bay_session.v1.MultiPlayerMode
 */
export enum MultiPlayerMode {
  /**
   * @generated from enum value: MULTI_PLAYER_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MULTI_PLAYER_MODE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: MULTI_PLAYER_MODE_ROTATION = 2;
   */
  ROTATION = 2,
}

/**
 * Describes the enum evenplay.bay_session.v1.MultiPlayerMode.
 */
export const MultiPlayerModeSchema: GenEnum<MultiPlayerMode> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 1);

/**
 * AutoPlayBalanceStatus — SMG-3075 projection of engine's per-user
 * autoplay-balance state. Mirrors qb.smg.AutoPlayBalanceStatus so a
 * consumer that previously read GetUser.autoPlayBalanceStatus can swap
 * to SessionPlayer.auto_play_balance_status without re-mapping integer
 * values:
 *   BALANCE_OK            = 0 — sufficient for configured bet amount.
 *   BALANCE_DOWNSHIFTED   = 1 — bet amount was reduced due to balance.
 *   BALANCE_INSUFFICIENT  = 2 — below minimum bet tier; autoplay paused.
 *
 * bay-session projects this from engine.user_details at snapshot build
 * time. When engine is unreachable the field falls back to the proto3
 * default (BALANCE_OK) — subscribers must treat that as "unknown,
 * engine down" rather than "definitely ok"; this is the same fallback
 * shape every other engine-sourced projection field uses.
 *
 * @generated from enum evenplay.bay_session.v1.AutoPlayBalanceStatus
 */
export enum AutoPlayBalanceStatus {
  /**
   * @generated from enum value: AUTO_PLAY_BALANCE_OK = 0;
   */
  AUTO_PLAY_BALANCE_OK = 0,

  /**
   * @generated from enum value: AUTO_PLAY_BALANCE_DOWNSHIFTED = 1;
   */
  AUTO_PLAY_BALANCE_DOWNSHIFTED = 1,

  /**
   * @generated from enum value: AUTO_PLAY_BALANCE_INSUFFICIENT = 2;
   */
  AUTO_PLAY_BALANCE_INSUFFICIENT = 2,
}

/**
 * Describes the enum evenplay.bay_session.v1.AutoPlayBalanceStatus.
 */
export const AutoPlayBalanceStatusSchema: GenEnum<AutoPlayBalanceStatus> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 2);

/**
 * WagerMode — per-player wager CATEGORY (SMG-3087, 2026-06-04). Values
 * describe the user-visible class of the next wager — NOT the specific
 * wallet currency. The wallet identifier (USD, TGPTS, FSPTS, ...) lives
 * independently on the `currency` string field of bets and per-currency
 * projections; the mapping (POINTS -> which points currency) is resolved
 * at AcceptBet time from venue/partner config, not from this enum.
 *
 * Why category-not-currency: adding a new partner does not require a
 * proto regen + cross-app rollout, because the user-visible distinction
 * (real money vs free play vs partner points) is unchanged. Specific
 * wallet routing belongs in venue_partner config.
 *
 * Spec §15.2.
 *
 * Field-number stability: WAGER_MODE_USD (=1) is renamed to
 * WAGER_MODE_MONEY; WAGER_MODE_TGP (=2) is renamed to WAGER_MODE_POINTS;
 * WAGER_MODE_FSP (=3) is REMOVED and its semantics collapse into
 * WAGER_MODE_POINTS (the partner is now distinguished by `currency`).
 * Field number 3 is `reserved` so a future neighbouring enum value
 * cannot accidentally re-occupy a slot whose semantics moved. v1.1 of
 * this proto has NOT shipped to production — the rename is a wire-
 * breaking change scoped to in-flight epic work, and every in-tree
 * caller is updated in the same commit.
 *
 * @generated from enum evenplay.bay_session.v1.WagerMode
 */
export enum WagerMode {
  /**
   * no active wager (the "paused" state)
   *
   * @generated from enum value: WAGER_MODE_NONE = 0;
   */
  NONE = 0,

  /**
   * real-money category; resolves to USD at AcceptBet
   *
   * @generated from enum value: WAGER_MODE_MONEY = 1;
   */
  MONEY = 1,

  /**
   * partner-points category; resolves to TGPTS / FSPTS via venue_partner config
   *
   * @generated from enum value: WAGER_MODE_POINTS = 2;
   */
  POINTS = 2,

  /**
   * free-play category; no wallet engagement
   *
   * @generated from enum value: WAGER_MODE_PRACTICE = 4;
   */
  PRACTICE = 4,
}

/**
 * Describes the enum evenplay.bay_session.v1.WagerMode.
 */
export const WagerModeSchema: GenEnum<WagerMode> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 3);

/**
 * MoneyCapability — what wagering is allowed at this station's jurisdiction.
 *
 * @generated from enum evenplay.bay_session.v1.MoneyCapability
 */
export enum MoneyCapability {
  /**
   * @generated from enum value: MONEY_CAPABILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MONEY_CAPABILITY_REAL_MONEY = 1;
   */
  REAL_MONEY = 1,

  /**
   * @generated from enum value: MONEY_CAPABILITY_POINTS_ONLY = 2;
   */
  POINTS_ONLY = 2,

  /**
   * @generated from enum value: MONEY_CAPABILITY_UNKNOWN_BAY = 3;
   */
  UNKNOWN_BAY = 3,
}

/**
 * Describes the enum evenplay.bay_session.v1.MoneyCapability.
 */
export const MoneyCapabilitySchema: GenEnum<MoneyCapability> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 4);

/**
 * BetOutcome — terminal state of a resolved bet; drives UI colour hints.
 *
 * @generated from enum evenplay.bay_session.v1.BetOutcome
 */
export enum BetOutcome {
  /**
   * @generated from enum value: BET_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BET_OUTCOME_WON = 1;
   */
  WON = 1,

  /**
   * @generated from enum value: BET_OUTCOME_LOST = 2;
   */
  LOST = 2,

  /**
   * @generated from enum value: BET_OUTCOME_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * @generated from enum value: BET_OUTCOME_EXPIRED = 4;
   */
  EXPIRED = 4,
}

/**
 * Describes the enum evenplay.bay_session.v1.BetOutcome.
 */
export const BetOutcomeSchema: GenEnum<BetOutcome> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 5);

/**
 * PlayerReadiness — per-player swing-readiness classifier surfaced on
 * SessionPlayer for the v1.1 D-series kiosk walkaway protection feature
 * (SMG-3147 v1.1 D2 — spec docs/specs/topgolf-features-2026-06-01.txt).
 * Drives both the kiosk "Ready" UX (D4) and the ProcessShot hit-rejection
 * gate (D3).
 *
 * Values:
 *
 *   * PLAY    — hits are accepted; the player can swing without
 *               further action. This is the default for the legacy
 *               pre-D1 row state (locked=FALSE, lock_status=ACTIVE
 *               on every existing row).
 *   * PAUSED  — hits are rejected because timeout_locked is TRUE, the
 *               player has no active wager mode, OR an FRS business rule
 *               blocks the next swing. timeout_locked is simulator-owned:
 *               the kiosk must wait for explicit simulator activation rather
 *               than offering a player-side confirmation gesture.
 *   * CONFIRM — the existing account / guardian confirmation gate is
 *               engaged. The kiosk surfaces the corresponding player or
 *               guardian recovery gesture; D3 rejects ProcessShot until all
 *               effective gates clear.
 *
 * Derived server-side from BaySessionPlayer fields in sessionsnap.Build.
 * Order of evaluation (first match wins):
 *   1. timeout_locked=TRUE                             -> PAUSED
 *   2. locked=TRUE AND lock_status != ACTIVE, or
 *      lock_status=GUARDIAN_REQUIRED                   -> CONFIRM
 *   3. wager_mode=NONE (any non-PRACTICE empty wager)  -> PAUSED
 *   4. business rule (FRS station, no detection /
 *      player is not the active FRS player)           -> PAUSED
 *   5. default                                          -> PLAY
 *
 * @generated from enum evenplay.bay_session.v1.PlayerReadiness
 */
export enum PlayerReadiness {
  /**
   * @generated from enum value: PLAYER_READINESS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAYER_READINESS_PLAY = 1;
   */
  PLAY = 1,

  /**
   * @generated from enum value: PLAYER_READINESS_PAUSED = 2;
   */
  PAUSED = 2,

  /**
   * @generated from enum value: PLAYER_READINESS_CONFIRM = 3;
   */
  CONFIRM = 3,
}

/**
 * Describes the enum evenplay.bay_session.v1.PlayerReadiness.
 */
export const PlayerReadinessSchema: GenEnum<PlayerReadiness> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 6);

/**
 * LockStatus — per-(user, station) lock-mode gate vocabulary backing the
 * v1.1 D-series kiosk walkaway protection (SMG-3166 v1.1 D1.5; supersedes
 * the D1 accept_cash_hit BOOLEAN). Each value names the REASON the gate
 * is engaged, which drives a distinct UX clear path on the client:
 * tap-Ready vs re-auth vs guardian-prompt.
 *
 *   * ACTIVE            — gate is clear; the player can swing. Default
 *                         for every row + every legacy carry-over. The
 *                         D3 hit-rejection gate is "lock_status ==
 *                         ACTIVE".
 *   * TURN_LOCKED       — a turn-boundary trigger (active-player change
 *                         or previous shot landed) engaged the gate.
 *                         Cleared by the D4 ready-button auth gesture.
 *   * IDLE_LOCKED       — idle-timeout trigger engaged the gate. Same
 *                         clear path as TURN_LOCKED but a distinct
 *                         reason for analytics and operator surfaces.
 *   * USER_LOCKED       — the user opted into the lock at the account
 *                         level (smg_user_details.locked = TRUE) and
 *                         the D4 JoinSession flow seeded the gate.
 *   * GUARDIAN_REQUIRED — G2-future: minor session has tripped a
 *                         guardian-prompt gate. Cleared only by a
 *                         distinct guardian-auth flow (not the
 *                         standard ready-button).
 *
 * Storage substrate: bay_session_players.lock_status VARCHAR(32) NOT NULL
 * DEFAULT 'ACTIVE' with a CHECK constraint mirroring the value list.
 * VARCHAR + CHECK (rather than a Postgres ENUM type) so the vocabulary
 * evolves via DROP CONSTRAINT / ADD CONSTRAINT instead of a column
 * rewrite. The Go layer (store.LockStatus) enforces the same vocabulary
 * at compile time.
 *
 * Today no message references this enum on the wire — D2's
 * PlayerReadiness projects the locked state for clients without
 * exposing the raw status. The enum is declared here so a future
 * SessionPlayer.lock_status surface (D3+) can pick it up without
 * another proto-layer landing.
 *
 * @generated from enum evenplay.bay_session.v1.LockStatus
 */
export enum LockStatus {
  /**
   * @generated from enum value: LOCK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOCK_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: LOCK_STATUS_TURN_LOCKED = 2;
   */
  TURN_LOCKED = 2,

  /**
   * @generated from enum value: LOCK_STATUS_IDLE_LOCKED = 3;
   */
  IDLE_LOCKED = 3,

  /**
   * @generated from enum value: LOCK_STATUS_USER_LOCKED = 4;
   */
  USER_LOCKED = 4,

  /**
   * @generated from enum value: LOCK_STATUS_GUARDIAN_REQUIRED = 5;
   */
  GUARDIAN_REQUIRED = 5,
}

/**
 * Describes the enum evenplay.bay_session.v1.LockStatus.
 */
export const LockStatusSchema: GenEnum<LockStatus> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 7);

/**
 * UserSessionState — per-player membership classifier surfaced on
 * PlayerState so mobile clients can gate the "join session" UX without
 * cross-referencing the SessionState roster. Mirrors the semantics of
 * PartnerKioskUpdate.UserSessionUpdateData.UserSessionState (BSA-4-4
 * parity field — see partner_service.proto).
 *
 *   * NOT_JOINED — the subject user is not in any station's roster.
 *   * NOT_ACTIVE — the subject is timeout-locked (SessionPlayer.is_idle),
 *                  OR, in pointer-based modes, is not the active-player
 *                  pointer.
 *   * ACTIVE     — the subject is not timeout-locked and, in OPEN/SOLO, is
 *                  joined; in every other mode, the subject is also the
 *                  active-player pointer. Other readiness gates control
 *                  swinging, not membership.
 *
 * Derived server-side from SessionState.play_mode, the subject's presence in
 * SessionState.players[], SessionPlayer.is_idle and SessionPlayer.is_active;
 * not persisted.
 *
 * @generated from enum evenplay.bay_session.v1.UserSessionState
 */
export enum UserSessionState {
  /**
   * @generated from enum value: USER_SESSION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_SESSION_STATE_NOT_JOINED = 1;
   */
  NOT_JOINED = 1,

  /**
   * @generated from enum value: USER_SESSION_STATE_NOT_ACTIVE = 2;
   */
  NOT_ACTIVE = 2,

  /**
   * @generated from enum value: USER_SESSION_STATE_ACTIVE = 3;
   */
  ACTIVE = 3,
}

/**
 * Describes the enum evenplay.bay_session.v1.UserSessionState.
 */
export const UserSessionStateSchema: GenEnum<UserSessionState> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 8);

/**
 * TournamentType classifies the ACCESS of the tournament currently
 * governing the bay (SMG-3537). Meaningful only while
 * play_mode == SESSION_PLAY_MODE_TOURNAMENT; UNSPECIFIED (the proto3
 * default) in every other mode. The three values mirror the core
 * tournament model's two independent booleans (tournament.is_private +
 * tournament.friends) and the ListTournamentRequest.TournamentAccess
 * filter enum:
 *   PUBLIC  — is_private = false                      (open leaderboard)
 *   PRIVATE — is_private = true,  friends = false     (invite-only, not a friends challenge)
 *   FRIENDS — is_private = true,  friends = true      (friends challenge)
 * Consumers wanting only the legacy public-vs-not binary can read the
 * sibling is_public_tournament bool instead (== tournament_type == PUBLIC).
 *
 * @generated from enum evenplay.bay_session.v1.TournamentType
 */
export enum TournamentType {
  /**
   * @generated from enum value: TOURNAMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOURNAMENT_TYPE_PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * @generated from enum value: TOURNAMENT_TYPE_PRIVATE = 2;
   */
  PRIVATE = 2,

  /**
   * @generated from enum value: TOURNAMENT_TYPE_FRIENDS = 3;
   */
  FRIENDS = 3,
}

/**
 * Describes the enum evenplay.bay_session.v1.TournamentType.
 */
export const TournamentTypeSchema: GenEnum<TournamentType> = /*@__PURE__*/
  enumDesc(file_bay_session_shared, 9);

